<template>
    <div :style="style" v-if="todisplay" v-show="isvisible" :class="{ 'c-AdvancedReports': true, [`c-name-${this.name || 'unnamed'}`]: true }">
        <v-snackbar multi-line :timeout="-1" :value="!!queryError" color="red">
            {{ queryError || 'This is a test of a large error message that you should see that might need to wrap it is very large.' }}

            <template v-slot:action="{ attrs }">
                <v-btn color="white"
                       text
                       v-bind="attrs"
                       @click="queryError = ''">
                    {{ Translate('Close') }}
                </v-btn>
            </template>
        </v-snackbar>
        <div style="display: flex; flex-direction: row; flex-grow: 1;">
            <div v-if="!colDefsLoaded" style="display: flex; flex-direction: column; flex-grow: 1; background-color: silver; align-items: center; justify-content: center;">
                <v-progress-circular :size="70"
                                     :width="7"
                                     color="purple"
                                     indeterminate></v-progress-circular>

            </div>
            <div v-if="colDefsLoaded" style="display: flex; flex-direction: column; flex-grow: 1;">
                <!-- Display when not in dashboard -->
                <div v-if="!controlData.IsDashboard">
                                   <span class="mt-0 ml-1 text-h6">{{ report_name }}</span>

                    <div v-if="ReadOnly" style="display: flex; flex-direction: row;">
                        <v-btn-toggle v-model="display_type" class="ml-0 mt-0" mandatory dense v-if="default_display_type == 2">
                            <!--<v-tooltip bottom open-delay="750">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" :disabled="true" v-show="false">
                                        <v-icon>mdi-table-arrow-down</v-icon>
                                    </v-btn>
                                </template>
                                Dynamic Table
                            </v-tooltip>-->

                            <v-tooltip bottom open-delay="750">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" :value="1">
                                        <v-icon>mdi-table-large</v-icon>
                                    </v-btn>
                                </template>
                                {{ Translate('Flat table') }}
                            </v-tooltip>

                            <v-tooltip bottom open-delay="750">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" :value="2">
                                        <v-icon>mdi-chart-pie</v-icon>
                                    </v-btn>
                                </template>
                                {{ Translate('Chart') }}
                            </v-tooltip>
                        </v-btn-toggle>
                    </div>

                    <div style="display: flex; flex-direction: row; align-items: center;" class="mb-1 mt-2 gridHeaderButtons">
                        <v-btn-toggle v-model="display_type" class="ml-0 mt-0" mandatory dense v-if="!ReadOnly">
                            <!--<v-tooltip bottom open-delay="750">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" :disabled="true" v-show="false">
                                        <v-icon>mdi-table-arrow-down</v-icon>
                                    </v-btn>
                                </template>
                                Dynamic Table
                            </v-tooltip>-->

                            <v-tooltip bottom open-delay="750">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" :value="1" style="height: 40px">
                                        <v-icon>mdi-table-large</v-icon>
                                    </v-btn>
                                </template>
                                {{ Translate('Flat table') }}
                            </v-tooltip>

                            <v-tooltip bottom open-delay="750">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" :value="2" :disabled="ChartIsDisabled" style="height: 40px">
                                        <v-icon>mdi-chart-pie</v-icon>
                                    </v-btn>
                                </template>
                                {{ Translate('Chart') }}
                            </v-tooltip>
                        </v-btn-toggle>

                        <!-- When in Edit mode, this daterange picker should also update the usestartend variable, which is why we use the updateSimDateRange method-->
                        <MyCalendar v-if="(ReadOnly && hasUserDateFilter) || !ReadOnly"
                                    :value="defaultTime"
                                    :width="ReadOnly ? '430px' : '460px'"
                                    :myclass="ReadOnly ? '' : 'ml-3'"
                                    :label="ReadOnly ? 'Select Date Range' : 'Simulate Date Range'"
                                    :isactive="(ReadOnly && hasUserDateFilter) || !ReadOnly"
                                    activeicon="mdi-calendar"
                                    inactiveicon="mdi-calendar-alert"
                                    :activecolor="''"
                                    inactivecolor="grey lighten-1"
                                    :showtooltip="!ReadOnly"
                                    @change="(range) => ReadOnly ? applyDateRangeHandler(range) : updateSimDateRange(range)">
                            <template v-slot:activetooltip>
                                {{Translate("Simulate the report using a range independent of the one set in the")}} 
                                <br />
                                {{Translate("Date/Time filter. Simulating has no effect on the published report.")}}
                            </template>
                            <template v-slot:inactivetooltip>
                                {{Translate("Simulate the report using a range independent of the one set in the")}} 
                                <br /> 
                                {{Translate("Date/Time filter. Simulating has no effect on the published report.")}}
                            </template>
                        </MyCalendar>

                        <v-btn v-if="ReadOnly && IsAnyViewFilterChoices" plain small :elevation="0" :color="show_filters ? 'primary' : ''" class="ml-2" @click="show_filters = !show_filters">
                            <v-badge color="primary" dot offset-y="25" offset-x="63" :value="IsAnyFilters">
                                <v-icon class="mr-1">mdi-filter</v-icon>Filters
                            </v-badge>
                        </v-btn>

                        <v-spacer></v-spacer>

                        <v-progress-circular v-if="false && query_in_progress" indeterminate color="primary" :size="20" class="mr-5 ml-5"></v-progress-circular>

                        <span v-if="System.DEBUG" class="mr-5" title="Query Elapsed Time">{{ query_elapsed }} </span>

                        <v-tooltip bottom>
                            <template v-slot:activator="{on, attrs}">
                                <v-btn small outlined class="mr-4" color="grey darken-2" v-bind="attrs" v-on="on" @click="cycleDurationFormats">
                                    {{ durationFormats[durationFormatIdx].text }}
                                </v-btn>
                            </template>
                            {{ Translate('Duration Time Format') }}
                            <br />
                            {{ Translate('Click to cycle through formats') }}
                        </v-tooltip>

                        <v-btn plain :elevation="0" _color="primary" class="ml-0" @click="autoSizeAllColumns" v-if="display_type < constants.DISPLAY_CHART">
                            <v-icon title="Size columns to content">mdi-arrow-left-right-bold</v-icon>
                        </v-btn>

                        <v-btn plain :elevation="0" _color="primary" class="ml-0" @click="sizeColumnsToFit" v-if="display_type < constants.DISPLAY_CHART">
                            <v-icon title="Size columns to fit">mdi-arrow-expand-horizontal</v-icon>
                        </v-btn>

                        <v-btn :disabled="query_in_progress" plain :elevation="0" _color="primary" class="ml-0" @click="Refresh">
                            <v-icon title="Refresh" :class="{ 'icon-spinner': query_in_progress }">mdi-cached</v-icon>
                        </v-btn>

                        <ColumnMenu v-if="colDefsLoaded && ReadOnly && display_type < constants.DISPLAY_CHART"
                                    :column_list="column_picker_list"
                                    :column_order="column_order"
                                    :columnDefs="columnDefs"
                                    :column_default_visibility="column_default_visibility"
                                    :setColumnsVisible="setColumnsVisible"
                                    :debugMode="System.DEBUG"
                                    :hideColumSelector="true"
                                    _showcolumnselector="showColumnSelector"
                                    @showdatafilters="showDataFilters">
                        </ColumnMenu>
                    </div>
                </div>
                <!-- Display when IN dashboard -->
                <div v-if="controlData.IsDashboard && ReadOnly">
                    <div style="display: flex; flex-direction: column;">
                        <c-Date-Range-Picker v-if="false"
                                             :style="{ visibility: ReadOnly && hasUserDateFilter ? 'initial' : 'hidden' }"
                                             style="max-width: 390px;"
                                             type="daterangepicker"
                                             :allowTime="true"
                                             :timePickerIncrement="1"
                                             :isDisabled="false"
                                             :default="defaultTime"
                                             placeholder="Select Date Range"
                                             :allowFutureDate="true"
                                             :allowPastDate="true"
                                             @apply-date-range="applyDateRangeHandler"
                                             @clear-date-range="clearDateRangeHandler">
                        </c-Date-Range-Picker>

                        
                        <div style="display: flex; flex-direction: row; align-items: center" class="mb-1 mt-2 gridHeaderButtons">
                            <v-btn-toggle v-model="display_type" style="align-self:flex-end" class="ml-0 mt-0 mr-2" mandatory dense v-if="default_display_type == 2">
                                <v-tooltip bottom open-delay="750">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" :value="1">
                                            <v-icon>mdi-table-large</v-icon>
                                        </v-btn>
                                    </template>
                                    Flat table
                                </v-tooltip>

                                <v-tooltip bottom open-delay="750">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" :value="2">
                                            <v-icon>mdi-chart-pie</v-icon>
                                        </v-btn>
                                    </template>
                                    Chart
                                </v-tooltip>
                            </v-btn-toggle>
                            <div style="margin-top:4px">
                                <MyCalendar v-if="ReadOnly && hasUserDateFilter" :value="defaultTime"
                                        width="430px"  
                                        label="Select Date Range"
                                        :isactive="true"
                                        activeicon="mdi-calendar"
                                        :iconOnly="false"
                                        :showtooltip="false"
                                        @change="applyDateRangeHandler">
                                </MyCalendar>
                            </div>
                            <v-spacer></v-spacer>

                            <v-btn v-if="ReadOnly && IsAnyViewFilterChoices" icon plain :elevation="0" :color="show_filters ? 'primary' : 'secondary'" class="ml-0" @click="show_filters = !show_filters">
                                <v-badge color="primary" dot offset-y="25" offset-x="11" :value="IsAnyFilters">
                                    <v-icon class="mr-1">mdi-filter</v-icon>
                                </v-badge>
                            </v-btn>

                            <v-tooltip bottom>
                                <template v-slot:activator="{on, attrs}">
                                    <v-btn small outlined color="grey darken-2" v-bind="attrs" v-on="on" @click="cycleDurationFormats">
                                        {{ durationFormats[durationFormatIdx].text }}
                                    </v-btn>
                                </template>
                                Duration Time Format<br />
                                Click to cycle through formats
                            </v-tooltip>

                            <v-btn plain :elevation="0" color="secondary" icon class="ml-0" @click="autoSizeAllColumns" v-if="display_type < constants.DISPLAY_CHART">
                                <v-icon title="Size columns to content">mdi-arrow-left-right-bold</v-icon>
                            </v-btn>

                            <v-btn plain :elevation="0" color="secondary" icon class="ml-0" @click="sizeColumnsToFit" v-if="display_type < constants.DISPLAY_CHART">
                                <v-icon title="Size columns to fit">mdi-arrow-expand-horizontal</v-icon>
                            </v-btn>

                            <v-btn :disabled="query_in_progress" plain :elevation="0" color="secondary" icon class="ml-0" @click="RefreshAll">
                                <v-icon title="Refresh" :class="{ 'icon-spinner': query_in_progress }">mdi-cached</v-icon>
                            </v-btn>

                            <ColumnMenu v-if="colDefsLoaded && ReadOnly && display_type < constants.DISPLAY_CHART"
                                        :btnclass="{ 'mr-2': false }"
                                        :column_list="column_picker_list"
                                        :column_order="column_order"
                                        :columnDefs="columnDefs"
                                        :column_default_visibility="column_default_visibility"
                                        :setColumnsVisible="setColumnsVisible"
                                        :debugMode="System.DEBUG"
                                        :hideColumSelector="true"
                                        _showcolumnselector="showColumnSelector"
                                        @showdatafilters="showDataFilters">
                            </ColumnMenu>
                        </div>
                    </div>
                </div>
                <AgGridVue v-if="colDefsLoaded" v-show="display_type < constants.DISPLAY_CHART && !nocolumns"
                           :key="unique_id"
                           :class="{ 'ag-theme-alpine': true }"
                           :style="{ display: 'flex', flexDirection: 'column', flexGrow: '1' }"
                           :initialState="initialState"
                           :columnDefs="columnDefs"
                           :defaultColDef="defaultColDef"
                           :serverSideDatasource="dataSource"
                           :cacheBlockSize="pageSize"
                           :maxConcurrentDatasourceRequests="1"
                           :enableCellTextSelection="true"
                           :sideBar="sideBar"
                           :enableCharts="false"
                           :enableRangeSelection="true"
                           :columnTypes="dataTypeDefinitions"
                           :autoGroupColumnDef="autoGroupColumnDef"
                           :maintainColumnOrder="true"
                           :groupDisplayType="groupDisplayType"
                           :removePivotHeaderRowWhenSingleValueColumn="false"
                           :pinnedBottomRowData="pinnedBottomRowData"
                           :getRowClass="getRowClass"
                           :tooltipShowDelay="500"
                           rowModelType="serverSide"
                           serverSidePivotResultFieldSeparator="|"
                           @gridReady="onGridReady"
                           @stateUpdated="stateUpdated"
                           @firstDataRendered="onFirstDataRendered"
                           @sortChanged="gridSortChanged"
                           @columnMoved="onColumnMoved">
                </AgGridVue>

                <AgChartsVue ref="agchart" :options="chartOptions" class="mychart" v-if="colDefsLoaded && display_type == constants.DISPLAY_CHART && !nocolumns">
                </AgChartsVue>

                <div v-if="colDefsLoaded && nocolumns"
                     style="flex-grow: 1; background-color: white; border: 1px solid silver; display: flex; flex-direction: column; align-content: center; align-items: center; justify-content: center;">
                    <div style="max-width: 280px; display: flex; flex-direction: column;" class="text-caption text-center">
                        <v-icon style="font-size: 80px;" class="mb-5">mdi-finance</v-icon>
                        Start building your report by selecting metrics from the panel on the right
                    </div>
                </div>
            </div>

            <ToolReportFields v-if="colDefsLoaded && !ReadOnly"
                              :isvisible="tool_visible === constants.TAB_METRICS"
                              :settings="settings"
                              :column_list="column_list"
                              :threshold_rules="threshold_rules"
                              :column_filters="column_filters"
                              :storageKey="storageKey"
                              :report_settings="report_settings"
                              :initial_userStartEnd="useStartEnd"
                              :initial_report_name="report_name"
                              :initial_report_description="report_description"
                              :initial_report_category="report_category"
                              :initial_show_manage_categories="show_manage_categories"
                              :control_category_actions="control_category_actions"
                              :openadvancedsettings="openadvancedsettings"
                              :notifychange="notifyreportchange"
                              :EventBus="EventBus"
                              :debugMode="System.DEBUG"
                              @filterschanged="notifyfilterschanged"
                              @updateparent:notifythresholdschanged="notifyThresholdsChanged"
                              @changeusestartend="(v) => updateUseStartEnd(v)"
                              @daterangechanged="saveCommonDateRange"
                              @namechanged="reportNameChanged"
                              @descriptionchanged="reportDescChanged"
                              @categorychanged="reportCategoryChanged"
                              @groupbyordered="groupbyordered"
                              @metricsordered="metricsordered">
            </ToolReportFields>

            <ToolReportChart v-if="colDefsLoaded && !ReadOnly"
                             :isvisible="tool_visible === constants.TAB_CHART_SETTINGS"
                             :settings="settings"
                             :column_list="column_list"
                             :initial_settings="initial_chart_settings"
                             :chartOptions="preparedChartOptions"
                             :pivot_columns="pivot_columns"
                             :legendFormatter="getChartSeriesText"
                             :notifychange="notifychartchange"
                             :notifyrefresh="notifychartrefresh"
                             :updateserialization="updatechartserialization">
            </ToolReportChart>

            <div v-if="colDefsLoaded && ReadOnly && FilterModal">
                <v-dialog :value="show_filters" :max-height="650" :max-width="600" scrollable persistent>
                    <v-card color="grey lighten-5"> 
                        <v-app-bar flat color="rgba(0, 0, 0, 0)" style="background-color: var(--v-navigation-base); height: 60px">
                            <v-toolbar-title class="title white--text pl-0">
                                {{ Translate('Report Filters') }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <busyIcon></busyIcon>
                        </v-app-bar>

                        <v-card-text class="mt-2">
                            <div style="overflow: auto; width: 100%; display: flex; flex-direction: column; flex-basis: 0; flex-grow: 1;">
                                <ToolReportFilters :isvisible="true"
                                                   :ReadOnly="true"
                                                   :settings="settings"
                                                   :column_list="column_filter_list"
                                                   :threshold_rules="threshold_rules"
                                                   :column_filters="column_filters"
                                                   :report_settings="report_settings"
                                                   :initial_column_filters="initial_column_filters"
                                                   :EventBus="EventBus"
                                                   :debugMode="System.DEBUG"
                                                   @filterschanged="notifyfilterschanged">
                                </ToolReportFilters>
                            </div>
                        </v-card-text>

                        <v-card-actions class="ma-2" style="justify-content: flex-end;">
                            <v-btn elevation={0} color="primary" @click="show_filters = false">
                                {{ Translate('Done') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
            <div v-if="colDefsLoaded && ReadOnly && !FilterModal && show_filters" class="c-ToolPanel_1 mx-auto w-100 pa-0" style="width: 100%; display: flex; flex-direction: column; min-width: 750px; max-width: 750px;">
                <div style="overflow: auto; width: 100%; display: flex; flex-direction: column; flex-basis: 0; flex-grow: 1;">
                    <v-expansion-panels accordion mandatory focusable>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <!--<template v-slot:actions>
                                    <v-icon title="Close" @click="show_filters = false">mdi-close</v-icon>
                                </template>-->

                                <span class="text-h6">
                                    Filters
                                </span>

                                <template v-slot:actions>
                                    <v-btn plain :elevation="0" color="primary" title="Clear All Filters" class="mr-3 v-btn--active"
                                           v-if="IsAnyFilters"
                                           @click.stop="clearAllFilters">Clear All</v-btn>
                                    <v-icon title="Close" @click="show_filters = false">mdi-close</v-icon>
                                </template>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content color="grey lighten-5">
                                <ToolReportFilters class="c-ToolReportFilters"
                                                   :isvisible="true"
                                                   :ReadOnly="true"
                                                   :settings="settings"
                                                   :column_list="column_filter_list"
                                                   :threshold_rules="threshold_rules"
                                                   :column_filters="column_filters"
                                                   :report_settings="report_settings"
                                                   :initial_column_filters="initial_column_filters"
                                                   :EventBus="EventBus"
                                                   :debugMode="System.DEBUG"
                                                   @filterschanged="notifyfilterschanged">
                                </ToolReportFilters>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>

                </div>
            </div>

            <v-card v-if="colDefsLoaded && tool_visible === constants.TAB_MODEL" class="c-ToolPanel_1 mx-auto w-100 pa-0" style="width: 100%; display: flex; flex-direction: column; max-width: 750px;">
                <v-card class="mx-auto w-100 pa-0" style="overflow: auto; width: 100%; display: flex; flex-direction: column; flex-basis: 0; flex-grow: 1;" :elevation="0">
                    <v-card-title>
                        Report Settings JSON
                    </v-card-title>
                    <v-card-text>
<pre>
{{ JSON.stringify(ReportModel,null,3) }}
</pre>
                    </v-card-text>
                </v-card>
            </v-card>

            <v-btn-toggle v-if="colDefsLoaded && !ReadOnly" class="mr-n2" _mandatory v-model="tool_visible" style="display: flex; flex-direction: column;">
                <v-btn color="extraLightGrey" large icon v-show="false">
                    <v-icon>mdi-cog-box</v-icon>
                </v-btn>
                <v-btn color="extraLightGrey" large icon style="border: 1px solid; border-radius: 0px;">
                    <v-icon title="Metric Selector" :color="tool_visible == 1 ? 'primary': 'secondary'">mdi-cogs</v-icon>
                </v-btn>
                <v-btn color="extraLightGrey" large icon v-show="false" style="border: 1px solid; border-radius: 0px;">
                    <v-icon title="Filters" :color="tool_visible == 2 ? 'primary': 'secondary'">mdi-filter-outline</v-icon>
                </v-btn>
                <v-btn color="extraLightGrey" large icon style="border: 1px solid; border-radius: 0px;">
                    <v-icon title="Chart Settings" :color="tool_visible == 3 ? 'primary': 'secondary'">mdi-tune</v-icon>
                </v-btn>
                <v-btn color="extraLightGrey" large icon v-show="false" style="border: 1px solid; border-radius: 0px;">
                    <v-icon title="All Settings" :color="tool_visible == 4 ? 'primary': 'secondary'">mdi-cogs</v-icon>
                </v-btn>
                <v-btn color="extraLightGrey" large icon v-if="System.DEBUG" style="border: 1px solid; border-radius: 0px;">
                    <v-icon title="Model" :color="tool_visible == 5 ? 'primary': 'secondary'">mdi-code-json</v-icon>
                </v-btn>
            </v-btn-toggle>
        </div>
        <!--<IconComponent v-show="false" />-->

        <v-dialog v-model="advancedSettingsVisible" max-width="590">
            <v-card>
                <v-card-title class="text-h5">
                    Advanced Settings
                </v-card-title>

                <v-card-text>

                    <h3 class="mt-2">Pagination</h3>
                    <v-text-subtitle>Server-side pagination settings.</v-text-subtitle>

                    <v-row no-gutters class="mt-5">
                        <v-col cols="4" class="mr-2">
                            <v-text-field dense outlined
                                          label="Normal Page Size"
                                          type="number"
                                          v-model="pageSize" :rules="pageSizeRules"
                                          hint="Controls the number of buckets to return before paginating">
                            </v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field dense outlined
                                          label="Presort Page Size"
                                          type="number"
                                          v-model="presortSize" :rules="presortSizeRules"
                                          hint="Controls the number of buckets to analyze on the server when sorting on a metric">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-divider class="mb-3"></v-divider>

                    <v-text-subtitle>Server-side pagination algorithm when not sorted by a metric. Metrics require bucket pagination, which is less efficient.</v-text-subtitle>
                    <v-radio-group v-model="serverPaginationMode">
                        <v-radio :value="1" label="After-Key Pagination"></v-radio>
                        <v-radio :value="2" label="Bucket Pagination"></v-radio>
                    </v-radio-group>

                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="green darken-1"
                           text
                           @click="advancedSettingsVisible = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    /* eslint-disable */

    import Vue from "vue";
    import _ from 'lodash';

    import utils from '../../Shared/utils.jsx';
    import helps from '../careHelpfulFunctions.jsx';
    import BaseComponent from './BaseComponentMixin.jsx';

    import 'ag-grid-enterprise';
    import { AgGridVue } from "ag-grid-vue";
    import { AgChartsVue } from 'ag-charts-vue';
    import { AgCharts } from 'ag-charts-enterprise';
    import 'ag-charts-enterprise';

    import cDateRangePicker from './vuecontrols/DateRangePicker.vue';
    import ToolReportFields from './vuecontrols/advancedHistory/agGridToolReportFields.vue';
    import ToolReportFilters from './vuecontrols/advancedHistory/agGridToolReportFilters.vue';
    import ToolReportChart from './vuecontrols/advancedHistory/agGridToolReportChart.vue';
    import ToolReportAllinOne from './vuecontrols/advancedHistory/agGridToolReportAllinOne.vue';
    import ColumnMenu from './vuecontrols/advancedHistory/columnMenu.vue';
    import MyCalendar from './vuecontrols/calendar.vue';

    import common from './vuecontrols/advancedHistory/common.js';
import { report } from "process";

    // If we move IconComponent into its own file, we can use .vue or .jsx and we
    // won't have to use the render function in this manner:
    const IconComponent = { // inline custom component for ag-grid
        methods: {
            sessionId() {
                return this.params && this.params.data ? this.params.data.sessionid : '...';
            },
            buttonClick(e) {
                alert('clicked ' + this.sessionId());
            },
        },
        render(h) {
            // h is a function that we call to create instances of any UI components.
            // Returning a button with an icon inside that can be clicked.
            const i = h('i',
                {
                    ['aria-hidden']: 'true',
                    class: 'v-icon notranslate mdi mdi-mdi mdi-magnify-plus-outline theme--light',
                    style: 'font-size: 20px;'
                }
            )
            const span = h('span',
                {
                    class: 'v-btn__content'
                },
                [i]
            );
            const button =
                h('button',
                    {
                        type: 'button',
                        class: 'v-btn v-btn--icon v-btn--round theme--light elevation-0 v-size--default secondary--text',
                        medium: 'true',
                        on: {
                            click: (e) => this.buttonClick(e)
                        }
                    },
                    [span]
                );

            return button;
        }
    };

    export default {
        name: "AdvancedReports",
        mixins: [BaseComponent],
        components: {
            AgGridVue,
            AgChartsVue,
            IconComponent,
            cDateRangePicker,
            ToolReportFields,
            ToolReportFilters,
            ToolReportChart,
            ToolReportAllinOne,
            ColumnMenu,
            MyCalendar,
        },
        data: function () {
            return {
                unique_id: utils.generateUUID(),
                datespan: '12/01/2023 12:00:00 AM - 12/01/2023 11:59:59 PM',
                useStartEnd: true,
                query_elapsed: '',
                query_result_size: 0,
                query_in_progress: false,
                query_refresh_pending: false,
                refreshOnReady: false,
                queryError: '',
                initialState: null,
                timezone: '',
                delay_expn: 0,

                datamodel: null,
                pinnedBottomRowData: null,
                defaultTime: 'today',
                baseurl: 'Apps/OSDemo/GetDetailHistoryComposite',
                baseurl_flat: 'Apps/ReportStudio/AdvancedReporting/QueryAggregation',
                baseurl_total: 'Apps/ReportStudio/AdvancedReporting/QueryTotalsRow',
                startDate: '2024-02-01T00:09:00.0000000Z',
                endDate: '2024-03-01T00:09:00.0000000Z',
                active_source: 'contact_data_points2',
                active_interval: '1h',
                autoGroupColumnDef: null,
                groupDisplayType: 'singleColumn',
                groupDisplayTypes: ['singleColumn', 'multipleColumns', 'groupRows'],
                colDefsLoaded: false,
                columnDefs: [],
                visibleColumnIds: [],
                columnVisibility: {},
                customerLookup: {},
                customMetrics: null,

                // These settings are passed down the chain of components
                settings: {
                    startDate: '2024-02-01T00:09:00.0000000Z',
                    endDate: '2024-03-01T00:09:00.0000000Z',
                    pageSize: 100,
                    presortSize: 1000,
                    serverPaginationMode: 1,
                    max_pivot_columns: 25,
                },

                default_display_type: common.constants.DISPLAY_FLAT_GRID,
                display_type: common.constants.DISPLAY_FLAT_GRID,
                tool_visible: common.constants.TAB_METRICS,
                column_list: [],
                column_filters: {
                    datetime: {
                        filterType: 'number',
                        type: 'inRange',
                        filter: 'now/d',
                        filterTo: 'now',
                        usage: 1
                    },
                    extralegtype: {
                        filterType: 'set',
                        values: ['Agent'],
                        mode: 'exclusive',
                        usage: 0
                    },
                },
                chartMaxValues: 100,
                initial_column_filters: null,

                viewonly_settings: {
                    column_picker_list: [],
                    column_filter_list: [],
                },
                show_filters: false,

                advancedSettingsVisible: false,
                pageSize: 100,
                presortSize: 1000,
                serverPaginationMode: 1,

                pageSizeRules: [ value => (value >= 10 && value <= 1000) || 'Between 10 - 1000 only' ],
                presortSizeRules: [ value => (value >= 10 && value <= 10000) || 'Between 10 - 10,000 only' ],

                durationFormatIdx: 0,
                durationFormats: [
                    { text: 'HH:MM:SS', value: 'HH:MM:SS' },
                    { text: 'Minutes', value: 'Minutes' },
                    { text: 'Seconds', value: 'Seconds' },
                ],

                constants: Object.freeze(common.constants),

                chartTheme: {
                    baseTheme: 'ag-default',
                    palette: {
                        fills: common.colors,
                        strokes: ['gray'],
                    }
                },

                defaultColDef: {
                    // set the default column width
                    width: 150,
                    // make every column editable
                    editable: false,
                    // make every column use 'text' filter by default
                    filter: 'agTextColumnFilter',
                    // enable floating filters by default
                    //floatingFilter: true,
                    // disable cell data types
                    //cellDataType: false,
                    menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
                    defaultAggFunc: 'avg',
                },
                sideBar: {
                    toolPanels: [
                        //{
                        //    id: 'customTools',
                        //    labelDefault: 'Report Fields',
                        //    labelKey: 'customTools',
                        //    iconKey: 'custom-tools',
                        //    toolPanel: "ToolReportFields",
                        //    toolPanelParams: {
                        //        title: 'Custom Metrics',
                        //        args: {
                        //            column_list: this.get_column_list,
                        //            notifychange: this.notifyreportchange,

                        //            columnDefs: this.getColumnDefs,
                        //            columnVisibility: this.getColumnVisibility,
                        //        }
                        //    },
                        //    minWidth: 180,
                        //    maxWidth: 725,
                        //    width: 725
                        //},
                        {
                            id: 'filters',
                            labelDefault: 'Data Filters',
                            labelKey: 'filters',
                            iconKey: 'filter',
                            toolPanel: 'agFiltersToolPanel',
                            minWidth: 180,
                            maxWidth: 725,
                            width: 725
                        },
                    ],
                    hiddenByDefault: true,
                    position: 'right',
                    //defaultToolPanel: 'customTools'
                },
                aggFuncs: {
                    cardinality: params => { return 0; },
                },
                dataTypeDefinitions: {
                    // override `date` to handle custom date format `dd/mm/yyyy`
                    dateColumn: {
                        filter: 'agDateColumnFilter',
                        //enableRowGroup: true,
                        //cellDataType: 'date',
                        resizable: true,
                        sortable: true,
                        keyCreator: params => {
                            return new Date(params.value).toISOString();
                        },
                        valueParser: params => {
                            if (params.newValue == null) {
                                return null;
                            }
                            // convert from ISO-8601
                            return new Date(params.newValue);
                        },
                        valueFormatter: params => {
                            // convert to locale date string
                            //debugger;

                            if(!params.value || params.value == '0001-01-01T00:00:00' || params.value == '0001-01-01T00:00:00Z' || params.value == -62135596800000) return '';
                            if(params.value == 'Never') return 'Never';

                            let dateOptions = {};
                            let timeOptions = {};
                            if (this.timezone){
                                dateOptions.timeZone = this.timezone;
                                timeOptions.timeZone = this.timezone;
                            }

                            const interval = this.report_settings.datetime_interval;
                            let show_interval_range = false;
                            let dateAndTime = true;
                            let includeEnd = false;
                            
                            
                            let startVal = new Date(params.value);
                            let unitType = '';
                            let units = 1;

                            if (params.colDef.colId == 'starttime') {

                                show_interval_range = !!this.report_settings.groupby?.find(x=> x.colId == 'datetime')?.show_interval_range;

                                switch (interval) {
                                    // Intervals where time (date AND time) is appropriate (dateAndTime = true is the default)
                                    case '15m':
                                    case '30m':
                                    case '1h':
                                    case '2h':
                                    case '3h':
                                    case '6h':
                                    case '12h':
                                        units = parseInt(interval.substr(0, interval.length - 1));
                                        unitType = interval.substr(interval.length - 1, 1);
                                        dateAndTime = true;
                                        includeEnd = true;
                                        
                                        if(show_interval_range){
                                            timeOptions.hour = '2-digit';
                                            timeOptions.minute =  '2-digit';
                                        }                                        
                                        break;

                                    // Intervals where only the date is appropriate (dateAndTime = false)
                                    case '1d': dateAndTime = false; includeEnd = false; break;
                                    case '2d':
                                    case '3d':
                                    case '180d':
                                        units = parseInt(interval.substr(0, interval.length - 1));
                                        unitType = 'd';
                                        dateAndTime = false;
                                        includeEnd = true;
                                        break;
                                    case 'week': unitType = 'w'; units = 1; dateAndTime = false; includeEnd = true; break;
                                    case 'month': unitType = 'M'; units = 1; dateAndTime = false; includeEnd = true; break;
                                    case 'quarter': unitType = 'M'; units = 3; dateAndTime = false; includeEnd = true; break;
                                    case 'year': unitType = 'y'; units = 1; dateAndTime = false; includeEnd = true; break;

                                    case 'dow':
                                    case 'hod':
                                    case 'h30od':
                                    case 'dowhod':
                                        dateAndTime = false;
                                        break;

                                    default:
                                        // Default to showing date and time for safety if a new interval is added
                                        dateAndTime = true;
                                        break;
                                }
                            }

                            const roundDate = (date, includeDate, includeTime) => 
                                            (includeDate ? (common.roundToInterval(date, interval).toLocaleDateString(undefined, dateOptions)) : '') + 
                                            (includeDate && includeTime ? ' ' : '') +
                                            (includeTime ? common.roundToInterval(date, interval).toLocaleTimeString(undefined, timeOptions) : '');

                            let res = roundDate(startVal, true, dateAndTime);
                            if(show_interval_range && includeEnd && unitType){
                                
                                if(isNaN(units)) 
                                    units = 1;

                                let selectedEnd = dayjs.tz(this.settings.endDate, dateOptions.timeZone).toDate();
                                let endVal = dayjs.tz(startVal, dateOptions.timeZone).add(units, unitType).toDate();

                                if(endVal > selectedEnd){
                                    endVal = selectedEnd;
                                }
                                
                                endVal = new Date(endVal.getTime() - 1000);
                                res += " - " + roundDate(endVal, !dateAndTime, dateAndTime)
                            }

                            return res;
                        },
                        suppressHeaderMenuButton: false,
                    },
                    dateOnlyColumn: {
                        filter: 'agDateColumnFilter',
                        //cellDataType: 'date',
                        resizable: true,
                        sortable: true,
                        keyCreator: params => {
                            return new Date(params.value).toISOString();
                        },
                        valueParser: params => {
                            if (params.newValue == null) {
                                return null;
                            }
                            // convert from ISO-8601
                            return new Date(params.newValue);
                        },
                        valueFormatter: params => {
                            // convert to locale date string
                            //debugger;
                            let options;
                            if (this.timezone)
                                options = { timeZone: this.timezone };

                            return (!params.value || params.value == '0001-01-01T00:00:00') ? ''
                                : (params.value == 'Never' || params.value == '9999-12-31T23:59:59.9999999') ? 'Never'
                                    :
                                    new Date(params.value).toLocaleDateString(undefined, options);
                        },
                        suppressHeaderMenuButton: false,
                    },
                    timeOnlyColumn: {
                        filter: 'agDateColumnFilter',
                        //cellDataType: 'date',
                        resizable: true,
                        sortable: true,
                        keyCreator: params => {
                            return new Date(params.value).toISOString();
                        },
                        valueParser: params => {
                            if (params.newValue == null) {
                                return null;
                            }
                            // convert from ISO-8601
                            return new Date(params.newValue);
                        },
                        valueFormatter: params => {
                            // convert to locale date string
                            //debugger;
                            let options;
                            if (this.timezone)
                                options = { timeZone: this.timezone };

                            return (!params.value || params.value == '0001-01-01T00:00:00') ? ''
                                : (params.value == 'Never' || params.value == '9999-12-31T23:59:59.9999999') ? 'Never'
                                    :
                                    new Date(params.value).toLocaleTimeString(undefined, options);
                        },
                        suppressHeaderMenuButton: false,
                    },
                    searchableTextColumn: {
                        filter: 'agTextColumnFilter',
                        //cellDataType: 'text',
                        resizable: true,
                        sortable: true,
                        filterParams: { debounceMs: 1000 },
                    },
                    dayOfWeekColumn: {
                        sortable: true,
                        resizable: true,
                        enableValue: true,
                        headerName: 'Day of Week',
                        filter: 'agSetColumnFilter',
                        filterParams: { values: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] },
                        valueFormatter: params => {
                            return params.value?.substring(1);
                        },
                    },
                    hourOfDayColumn: {
                        sortable: true,
                        resizable: true,
                        enableValue: true,
                        headerName: 'Hour of Day',
                        filter: 'agNumberColumnFilter',
                        valueFormatter: params => {
                            if (params.value)
                                return `${params.value}:00`;
                            else
                                return '';
                        },
                    },
                    halfHourOfDayColumn: {
                        sortable: true,
                        resizable: true,
                        enableValue: true,
                        headerName: 'Half Hour of Day',
                        filter: 'agNumberColumnFilter',
                        valueFormatter: params => {
                            if (params.value)
                                return params.value;
                            else
                                return '';
                        },
                    },
                    dowAndHodColumn: {
                        sortable: true,
                        resizable: true,
                        enableValue: true,
                        headerName: 'Day of Week / Hour of Day',
                        filter: 'agTextColumnFilter',
                        valueFormatter: params => {
                            return params.value?.substring(1);
                        },
                    },
                    directionColumn: {
                        sortable: true,
                        resizable: true,
                        //enableRowGroup: true,
                        enablePivot: true,
                        filter: 'agSetColumnFilter',
                        filterParams: { values: ['inbound', 'outbound'] },
                        cellClass: 'text-capitalize',
                        //valueFormatter: params => {
                        //    // convert to Capitalized
                        //    return params.value?.substring(0, 1).toUpperCase() + params.value?.substring(1);
                        //},
                    },
                    booleanColumn: {
                        sortable: true,
                        resizable: true,
                        cellDataType: 'boolean',
                        filter: 'agSetColumnFilter',
                        filterParams: { values: ['true', 'false'] },
                        cellRenderer: 'agCheckboxCellRenderer',
                    },
                    textSetColumn: {
                        sortable: true,
                        resizable: true,
                        //enableRowGroup: true,
                        enablePivot: true,
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            refreshValuesOnOpen: true
                        }
                    },
                    channelTypeColumn: {
                        sortable: true,
                        resizable: true,
                        //enableRowGroup: true,
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            values: this.getUniqueColValues('timelinetype'),
                            refreshValuesOnOpen: true,
                            valueFormatter: params => {
                                if (params.value && params.value.substring(0, 14) == 'CustomChannel~')
                                    return params.value.substring(14);
                                else
                                    return params.value;
                            },
                            comparator: (x, y) => {
                                let a = x;
                                let b = y;
                                if (a.substring(0, 14) == 'CustomChannel~') a = a.substring(14);
                                if (b.substring(0, 14) == 'CustomChannel~') b = b.substring(14);
                                return a > b ? 1 : a < b ? -1 : 0;
                            }
                        },
                        valueFormatter: params => {
                            if (params.value && params.value.substring(0, 14) == 'CustomChannel~')
                                return params.value.substring(14);
                            else
                                return params.value;
                        },
                    },
                    durationColumn: {
                        sortable: true,
                        resizable: true,
                        enableValue: true,
                        filter: 'agNumberColumnFilter',
                        cellClass: 'right-aligned-cell',
                        headerClass: 'ag-right-aligned-header',
                        valueFormatter: params => {
                            let seconds = params.value;
                            if (!(typeof seconds === 'number'))
                                return '';

                            // Round the input seconds to the nearest whole number
                            seconds = Math.round(seconds);

                            let result = "";

                            switch (this.durationFormat) {
                                case 'HH:MM:SS':
                                    let neg = false;
                                    if (seconds < 0) {
                                        seconds = -seconds;
                                        neg = true;
                                    }
                                    seconds = Math.floor(seconds);

                                    let hours = Math.floor(seconds / (60 * 60));
                                    seconds = seconds - (hours * 60 * 60);

                                    let minutes = Math.floor(seconds / 60);
                                    seconds = seconds - (minutes * 60);

                                    if (hours)
                                        result = ((hours <= 9) ? "0" : "") + hours + ":" + ((minutes <= 9) ? "0" : "") + minutes + ":" + ((seconds <= 9) ? "0" : "") + seconds;
                                    else if (minutes)
                                        result = ((minutes <= 9) ? "0" : "") + minutes + ":" + ((seconds <= 9) ? "0" : "") + seconds;
                                    else if (seconds)
                                        result = "00:" + ((seconds <= 9) ? "0" : "") + seconds;
                                    else
                                        result = "00:00";

                                    if (neg) result = `-${result}`;
                                    break;

                                case 'Minutes':
                                    result = (seconds / 60).toFixed(2);
                                    break;

                                case 'Seconds':
                                default:
                                    result = seconds.toFixed(0);
                                    break;
                            }

                            return result;
                        }
                    },
                    countColumn: {
                        sortable: true,
                        resizable: true,
                        enableValue: true,
                        filter: 'agNumberColumnFilter',
                        cellClass: 'right-aligned-cell',
                        headerClass: 'ag-right-aligned-header',
                        valueFormatter: params => {
                            if (typeof params.value === 'number')
                                return params.value;
                            else
                                return '0';
                        }
                    },
                    floatColumn: {
                        sortable: true,
                        resizable: true,
                        enableValue: true,
                        filter: 'agNumberColumnFilter',
                        cellClass: 'right-aligned-cell',
                        headerClass: 'ag-right-aligned-header',
                        valueFormatter: params => {
                            if (typeof params.value === 'number')
                                return params.value.toFixed(1);
                            else
                                return '';
                        }
                    },
                    percentColumn: {
                        sortable: true,
                        resizable: true,
                        enableValue: true,
                        filter: 'agNumberColumnFilter',
                        cellClass: 'right-aligned-cell',
                        headerClass: 'ag-right-aligned-header',
                        valueFormatter: params => {
                            if (typeof params.value === 'number')
                                return (params.value * 100).toFixed(1) + '%';
                            else
                                return '';
                        }
                    },
                    customerIDColumn: {
                        sortable: true, resizable: true, valueFormatter: this.customerLookupFormatter, enableRowGroup: false, enablePivot: true,
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            values: this.getUniqueColValues('ownerid'),
                            valueFormatter: this.customerLookupFormatter,
                            comparator: this.customerLookupComparator
                        }
                    },
                    userIDColumn: {
                        sortable: true,
                        resizable: true,
                        valueFormatter: this.userLookupFormatter,
                        //enableRowGroup: true,
                        enablePivot: true,
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            values: this.getUniqueColValues('userid'),
                            valueFormatter: this.userLookupFormatter,
                            comparator: this.userLookupComparator
                        }
                    },
                    currencyColumn: {
                        sortable: true,
                        resizable: true,
                        enableValue: true,
                        filter: 'agNumberColumnFilter',
                        cellClass: 'right-aligned-cell',
                        headerClass: 'ag-right-aligned-header',
                        valueFormatter: params => {
                            if (typeof params.value === 'number')
                                return this.f_currency(params.value);
                            else
                                return '';
                        }
                    },
                    phoneNumColumn: {
                        sortable: true,
                        resizable: true,
                        valueFormatter: this.phoneNumLookupFormatter,
                        //enableRowGroup: true,
                        enablePivot: true,
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            //values: this.getUniqueColValues('userid'),
                            valueFormatter: this.phoneNumLookupFormatter,
                            comparator: this.phoneNumLookupComparator
                        }
                    }
                },
                treeData: true,
                groupColDef_byMasterID: {
                    filter: 'agGroupColumnFilter',
                    headerName: 'Start Date',
                    cellRendererParams: {
                        innerRenderer: (params) => {
                            return (!params.data.starttime || params.data.starttime == '0001-01-01T00:00:00') ? ''
                                : params.data.starttime == 'Never' ? 'Never'
                                    :
                                    new Date(params.data.starttime).toLocaleDateString() + ' ' + new Date(params.data.starttime).toLocaleTimeString();
                        },
                    },
                },
                groupColDef_Normal: {
                    filter: 'agGroupColumnFilter',
                    flex: 1,
                    minWidth: 250,
                    maxWidth: 350,
                    //cellRendererParams: {
                    //    innerRenderer: (params) => {
                    //        //debugger;
                    //        return params.valueFormatted || params.value;
                    //    }
                    //}
                },
                datetime_interval: '1h',
                
                current_page: { from: 0, size: 100, after_key: null },
                next_after_key: null,

                query_duration: 0,
                total_rows: 0,
                using_aggs: false,
                report_settings: {},
                filter_settings: {
                    datetime: {
                        filterType: 'number',
                        type: 'inRange',
                        filter: 'now/d',
                        filterTo: 'now',
                        usage: 1
                    },
                    extralegtype: {
                        filterType: 'set',
                        values: ['Agent'],
                        mode: 'exclusive',
                        usage: 0
                    },
                },
                threshold_rules: [],
                column_state: {},
                initial_chart_settings: {},
                pivot_columns: [],

                dataSource: {
                    getRows: async (server) => {
                        const params = server.request;

                        // params: {"startRow":0,"endRow":100,"sortModel":[{"sort":"asc","colId":"starttime"}],"filterModel":{}}
                        // params: {"startRow":0,"endRow":100,"sortModel":[{"sort":"desc","colId":"prequeuetime"}],
                        //          "filterModel":{"callerid":{"filterType":"text","type":"contains","filter":"5432"}}}

                        switch (this.display_type) {
                            case common.constants.DISPLAY_DYNAMIC_GRID: // Dynamic Table
                                {
                                    const output = await this.queryDynamicTable(params);
                                    server.success(output);
                                    break;
                                }

                            case common.constants.DISPLAY_FLAT_GRID: // Flat Table
                            case common.constants.DISPLAY_CHART: // Chart
                                {
                                    const output = await this.queryFlatTable(params);
                                    server.success(output);
                                    break;
                                }
                        }
                    }
                },

                chartTypeSettings: {
                    type: 'bar',
                },
                preparedChartOptions: {
                    axes: [],
                    series: [],
                },
                chartOptions: {
                    zoom: {
                        enableSelecting: true,
                    },
                    axes: [
                    //    { type: 'category', position: 'bottom', title: { enabled: true, text: 'Month' }, label: { enabled: true, color: 'blue' } },
                    //    { type: 'number', position: 'left', title: { enabled: true, text: 'Ice Cream' }, label: { format: '$#{0>6.2f}' }, keys: ['iceCreamSales'], min: 0 },
                    //    { type: 'number', position: 'right', title: { enabled: true, text: 'Count1' }, label: { format: '#{0>3.0f}', color: 'green' }, keys: ['group1.count'], min: 0, max: 30 },
                    //    { type: 'number', position: 'right', title: { enabled: true, text: 'Count2' }, label: { format: '#{0>3.0f}', color: 'blue' }, keys: ['group2.count'], min: 0, max: 30 },
                    //    { type: 'number', position: 'left', title: { enabled: true, text: 'Temp' }, label: { format: '#{0>1.2f}', color: 'orange' }, keys: ['avgTemp'], min: 0 },
                    ],
                    data: [
                    //    { month: 'Jan', source: 'neighboors', avgTemp: 2.3, iceCreamSales: 162000, kids: 40, group1: { count: 5 }, group2: { count: 10 } },
                    //    { month: 'Feb', source: 'neighboors', avgTemp: 3.1, iceCreamSales: 182000, kids: 50, group1: { count: 6 }, group2: { count: 15 } },
                    //    { month: 'Mar', source: 'neighboors', avgTemp: 6.3, iceCreamSales: 302000, kids: 70, group1: { count: 7 }, group2: { count: 20 } },
                    //    { month: 'May', source: 'neighboors', avgTemp: 16.2, iceCreamSales: 800000, kids: 90, group1: { count: 8 }, group2: { count: 25 } },
                    //    { month: 'Jul', source: 'neighboors', avgTemp: 22.8, iceCreamSales: 1254000, kids: 120, group1: { count: 9 }, group2: { count: 22 } },
                    //    { month: 'Sep', source: 'neighboors', avgTemp: 14.5, iceCreamSales: 950000, kids: 100, group1: { count: 7 }, group2: { count: 17 } },
                    //    { month: 'Nov', source: 'neighboors', avgTemp: 8.9, iceCreamSales: 200000, kids: 60, group1: { count: 5 }, group2: { count: 12 } },
                    ],
                    series: [
                    //    { type: 'bar', xKey: 'month', yKey: 'iceCreamSales' },
                    //    { type: 'bar', xKey: 'month', yKey: 'avgTemp' },
                    //    { type: 'line', xKey: 'month', yKey: 'group1.count' },
                    //    { type: 'line', xKey: 'month', yKey: 'group2.count' },
                    ],
                },
                custom_chart_options: {},
                custom_chart_legend: {},
                customize_series: null,
                customize_axes: null,
                suppress_metric_suffix: false,

                report_name: '',
                report_description: '',
                report_category: null,
                show_manage_categories: false,
                control_category_actions: null,
                totals_row_class: 'grid-totals-row',
                isPillReordering: false,
            }
        },
        created() {
            if ((this.controlData.DataType === 'URL' || this.controlData.DataType === undefined) && this.controlData.DataURL)
            {
                this.modelurl = utils.compile(this, this.controlData.DataURL);
            }
            else if (this.controlData.DataType === 'RawInterpolated' && this.controlData.DataRaw)
            {
                this.modelvalue = utils.compileObject(this, this.controlData.DataRaw);
            }

            if (this.controlData.BaseQueryURL) {
                try {
                    const baseurl_expn = utils.compile(this, this.controlData.BaseQueryURL)
                    this.baseurl_flat = utils.evaluate(baseurl_expn, this);
                }
                catch (err) {
                    console.log('Error interpolating BaseQueryURL: ' + this.controlData.BaseQueryURL + '; error: ' + err.message);
                }
            }

            if (this.controlData.BaseQueryTotalsURL) {
                try {
                    const baseurl_expn = utils.compile(this, this.controlData.BaseQueryTotalsURL)
                    this.baseurl_total = utils.evaluate(baseurl_expn, this);
                }
                catch (err) {
                    console.log('Error interpolating BaseQueryTotalsURL: ' + this.controlData.BaseQueryTotalsURL + '; error: ' + err.message);
                }
            }

            if (this.ReadOnly)
                this.tool_visible = undefined;

            if (this.controlData.RefreshInterval)
                this.delay_expn = utils.compileExpression(this, this.controlData.RefreshInterval);

            if (this.controlData.ReportName)
                try {
                    let expn = utils.compile(this, this.controlData.ReportName);
                    this.report_name = utils.evaluate(expn, this);
                }
                catch (err) {
                    console.log('Error interpolating ReportName: ' + this.controlData.ReportName + '; error: ' + err.message);
                }

            if (this.controlData.ReportDescription)
                try {
                    let expn = utils.compile(this, this.controlData.ReportDescription);
                    this.report_description = utils.evaluate(expn, this);
                }
                catch (err) {
                    console.log('Error interpolating ReportDescription: ' + this.controlData.ReportDescription + '; error: ' + err.message);
                }

            if (this.controlData.Category)
                try {
                    let expn = utils.compile(this, this.controlData.Category);
                    let catId = utils.evaluate(expn, this);
                    this.report_category = catId;
                }
                catch (err) {
                    console.log(err.message);
                }

            if (this.controlData.ShowManageCategories)
                try {
                    let expn = utils.compile(this, this.controlData.ShowManageCategories);
                    let val = utils.evaluate(expn, this);
                    this.show_manage_categories = val === true || val === "true";
                }
                catch (err) {
                    console.log(err.message);
                }

            if (this.controlData.CategoryActions)
                    this.control_category_actions = this.controlData.CategoryActions;
                
            if (this.controlData.PublishReportName) {
                let vueSet = utils.helpers.convertSetValueToVueSet(this.controlData.PublishReportName, 'value');
                this.setReportNameFunction = new Function('value', 'context', 'util', 'vue', `with (context) { ${vueSet} }`);
            }
            if (this.controlData.PublishReportDescription) {
                let vueSet = utils.helpers.convertSetValueToVueSet(this.controlData.PublishReportDescription, 'value');
                this.setReportDescriptionFunction = new Function('value', 'context', 'util', 'vue', `with (context) { ${vueSet} }`);
            }

            if (this.controlData.PublishCategory) {
                let vueSet = utils.helpers.convertSetValueToVueSet(this.controlData.PublishCategory, 'value');
                this.setReportCategoryFunction = new Function('value', 'context', 'util', 'vue', `with (context) { ${vueSet} }`);
            }

            this.EventBus = new Vue();
        },
        //Created Replaced with preRenderComplete
        computed: {
            ReadOnly: function () {
                return !!this.controlData.ReadOnly;
            },
            FilterModal: function () {
                return !!this.controlData.FilterModal;
            },
            IsAnyFilters: function () {
                if (this.ReadOnly) {
                    if (!this.column_filters) return false;

                    // If any filters are present that have more than a usage flag, return true
                    return Object.keys(this.column_filters).some(a => {
                        const f = this.column_filters[a];
                        if (!f) return false;

                        if (a == 'starttime' || a == 'datetime')
                            return false;
                        if ('usage' in f) {
                            if (f.usage < 2)
                                return f.usage > 0 && Object.keys(f).length > 1;
                            else {
                                const i = this.initial_column_filters[a];
                                // If the initial and the current filter aren't the same, return true and show filter icon
                                return !common.compareObjects(f, i);
                            }
                        }
                        else
                            return true;
                    });
                }
                else
                    return this.column_filters && Object.keys(this.column_filters).length > 0;
            },
            IsAnyViewFilterChoices: function () {
                // Returns true if there are any filters available to the user in view or dashboard mode, whether they are being used by user or not.
                // Used to show or hide filter icon if there are no filters to choose from.
                
                return Object.keys(this.filter_settings).filter(k=> k != 'datetime' && k != 'starttime' && this.filter_settings[k].usage > 0).length > 0;
            },
            ChartIsDisabled: function () {
                if (!this.report_settings.groupby)
                    return false;

                return ((this.report_settings.groupby.length > 1 && !this.report_settings.pivoton) || this.report_settings.groupby.length > 2);
            },
            TimeZone: function () {
                if (!this.timezone_expn && this.controlData.TimeZone) {
                    this.timezone_expn = utils.compile(this, this.controlData.TimeZone);
                }

                if (this.timezone_expn)
                    return utils.evaluate(this.timezone_expn, this);
                else
                    return '';
            },
            Filters: function () {
                if (!this.filters_expn && this.controlData.Filters) {
                    this.filters_expn = utils.compile(this, this.controlData.Filters);
                }

                if (this.filters_expn)
                    return utils.evaluate(this.filters_expn, this);
                else
                    return '';
            },
            StartDate: function () {
                return this.settings.startDate;
            },
            EndDate: function () {
                return this.settings.endDate;
            },

            style() {
                return {
                    overflow: "auto",
                    display: "flex",
                    flexDirection: "column",
                    // minHeight: "400px",
                    padding: this.controlData.IsDashboard ? '0 8px' : '8px',
                    ...this.sizeStyle,
                };
            },
            storageKey: function () {
                return `historyGrid-${this.parentType}-${this.controlData.Name || 'unnamed'}-${this.controlData.$objectid || 'noid'}`;
            },
            modelurlvalue: function () {
                if (this.modelurl)
                    return utils.evaluate(this.modelurl, this);
                else
                    return '';
            },
            modelrawvalue: function () {
                if (this.modelvalue)
                    return utils.evaluateObject(this.modelvalue, this);
                else
                    return [];
            },

            toolColumnVisibility: function () {
                return this.columnVisibility;
            },
            toolColumnDefs: function () {
                return this.columnDefs;
            },
            suppressAggFuncInHeader: function () {
                return this.display_type >= common.constants.DISPLAY_FLAT_GRID && !!this.report_settings.pivoton;
            },
            nocolumns: function () {
                if (this.columnDefs)
                    return !this.columnDefs.some(a => a.colId && !a.hide);
                else
                    return true;
            },
            hasUserDateFilter: function () {
                // For ReadOnly mode, this returns true if there is a date filter that allows user filtering
                return this.initial_column_filters &&
                    ((this.initial_column_filters.datetime && this.initial_column_filters.datetime.usage > 0) ||
                    (this.initial_column_filters.starttime && this.initial_column_filters.starttime.usage > 0));
            },

            durationFormat: function () {
                return this.durationFormats[this.durationFormatIdx].value;
            },

            column_picker_list: function () {
                if (this.ReadOnly) {
                    // this.column_list.filter(a => this.column_state.columnOrder.includes(a.ColId)),
                    // return this.viewonly_settings.column_picker_list;
                    if (this.column_state.columnOrder)
                        return this.columnDefs.filter(a => this.column_state.columnOrder.includes(a.colId)).map(a => ({
                            ColId: a.colId,
                            Title: a.headerName,
                        }));
                    else
                        return this.column_list;
                }
                else
                    return this.column_list;
            },
            column_order: function () {
                if (this.column_state && this.column_state.columnOrder)
                    return this.column_state.columnOrder;
                else
                    return this.columnDefs.filter(a => a.colId && !a.hide).map(b => b.colId );
            },
            column_filter_list: function () {
                // This array is specifically used in the ReadOnly mode to pass into the Report Filters panel. It must
                // only show fields that have been chosen at design time by marking the usage option.

                const results = [];
                for(let k in this.filter_settings){
                    let filter = this.filter_settings[k];
                    if(filter.usage <= 0) continue;

                    let underscorePosition = 0;
                    do{
                        let found = this.column_list.find(c => c.ColId === k);
                        if(found){
                            results.push(found);
                            break;
                        }else{
                            underscorePosition = k.lastIndexOf('_');
                            if(underscorePosition >= 0) 
                                k = k.substring(0,underscorePosition);
                        }
                    }while(underscorePosition > 0);
                }

                return results;        
            },
            column_default_visibility: function () {
                return {};
            },

            ReportModel: function () {
                let columns;
                if (this.column_state && this.column_state.columnOrder) {
                    // Grab the columns from the state order list
                    columns = this.column_state.columnOrder.map(c => ({ colId: c }));

                    // If any columns are visible that aren't in the state order list, add them
                    for (let c of this.columnDefs.filter(a => a.colId && !a.hide)) {
                        if (!columns.some(a => a.colId == c.colId))
                            columns.push({ colId: c.colId });
                    }
                }
                else
                    columns = this.columnDefs.filter(a => a.colId && !a.hide).map(b => ({ colId: b.colId }));

                columns = columns.filter(a => !a.colId.startsWith('pivot_'));

                if (this.column_state.columnSizing)
                    for (let z of this.column_state.columnSizing) {
                        const c = columns.find(a => a.colId == z.colId);
                        if (c) c.width = z.width;
                    }

                if (this.column_state.leftPinned)
                    for (let z of this.column_state.leftPinned) {
                        const c = columns.find(a => a.colId == z);
                        if (c) c.pinLeft = true;
                    }

                if (this.column_state.rightPinned)
                    for (let z of this.column_state.rightPinned) {
                        const c = columns.find(a => a.colId == z);
                        if (c) c.pinRight = true;
                    }

                if (this.column_state.sort)
                    for (let z of this.column_state.sort) {
                        const c = columns.find(a => a.colId == z.colId);
                        if (c) c.sort = z.sort;
                    }

                const groupmods = [...new Set(this.report_settings.groupby.map(a => a.colId))].map(a => common.column_lookup[a]).flatMap(a => a && a.Dependencies ? a.Dependencies.Modules : []);
                const metricmods = [...new Set(this.report_settings.metrics.map(a => a.colId))].map(a => common.column_lookup[a]).flatMap(a => a && a.Dependencies ? a.Dependencies.Modules : []);
                const modules = [...new Set(groupmods.concat(metricmods))];
                const filter_settings = this.filter_settings;

                // Ensure we don't save a filter with only {usage:0} -- that would be a waste
                for (let key of Object.keys(filter_settings)) {
                    const item = filter_settings[key];
                    if (Object.keys(item).length < 1 || (Object.keys(item).length == 1 && 'usage' in item && !item.usage))
                        delete filter_settings[key];
                }

                return {
                    display_type: this.display_type,
                    filters: filter_settings,
                    thresholds: this.threshold_rules,
                    columnstate: columns,
                    report: this.report_settings,
                    dependencies: {
                        modules: modules
                    },
                    charting: this.display_type == common.constants.DISPLAY_CHART  ? {
                        series: this.customize_series.filter(a => !a.yKey?.includes('|')), // filter out pivot-generated series
                        axes: this.charting_axes,
                        options: this.custom_chart_options,
                        legend: this.custom_chart_legend,
                        maxValues: this.chartMaxValues,
                        typeSettings: this.chartTypeSettings,
                    } : null,
                };
            },
            charting_axes: function () {
                const pivoting = !!this.report_settings.pivoton;
                const axes = [];
                for (let a of this.customize_axes) {
                    const copied_axes = { ...a };
                    if (pivoting)
                        delete copied_axes.keys; // When using pivoting we don't want to save the keys with the report, they will be auto-generated from the data
                    axes.push(copied_axes);
                }
                return axes;
            },
        },
        beforeDestroy() {
            //window.removeEventListener('resize', this.updateDimensions);
        },
        destroyed() {
            if (this.interval) clearInterval(this.interval);
        },
        async mounted() {
            //window.addEventListener('resize', this.updateDimensions);
            //this.getWindowDimensions();

            //const oldDateRange = this.System.LocalStorage(this.storageKey + '-daterange');
            //if (oldDateRange) {
            //    this.settings.startDate = oldDateRange.split(' - ')[0];
            //    this.settings.endDate = oldDateRange.split(' - ')[1];
            //}
            //else {
            //    this.settings.startDate = '2024-05-01T00:00';
            //    this.settings.endDate = '2024-06-01T00:00';
            //}

            //if(!this.ReadOnly && !this.controlData.InDashboard){
                // When in edit mode, we want the date picker to default to today just like the date/time filter.
                let startDate = common.getRelativeDateFromFilter('now/d');
                let endDate = common.getRelativeDateFromFilter('now', true);

                this.settings.startDate = dayjs(startDate).format("YYYY-MM-DDTHH:mm:ss.SSS");
                this.settings.endDate = dayjs(endDate).format("YYYY-MM-DDTHH:mm:ss.SSS");

            //}

            this.defaultTime = JSON.stringify({ startDate: this.settings.startDate, endDate: this.settings.endDate });

            console.log(`calendar Report mounted initial defaultTime: ${this.defaultTime}`);

            const olddisplay_type = this.System.LocalStorage(this.storageKey + '-display_type');
            if (olddisplay_type)
                this.display_type = parseInt(olddisplay_type);

            this.autoGroupColumnDef = this.groupColDef_Normal;
        },
        methods: {
            async preRenderComplete() {
                this.finishRenderHandler(this);
                // Look for a form_changed_indicator up the parent hierarchy
                let p = this.$parent;
                while (p && (!('cc_form_changed_indicator' in p) || !p.cc_form_changed_active))
                    p = p.$parent;

                if (p) {
                    p.cc_form_changed_linked = true;
                    p.cc_form_changed_form = this;
                    this.notify_object = p;
                }

                await common.loadLookupTables(this._uid, this.ReadOnly);

                this.column_list = common.column_list;
                this.columnDefs = common.getColumnDefs(null, this.applyThresholdStyling);
                
                await this.loadReportModel();

                this.colDefsLoaded = true;
                const delay = this.delay_expn ? parseInt(utils.evaluate(this.delay_expn, this)) || 0 : 0;
                if (delay)
                    this.interval = setInterval(() => {
                        this.Refresh();
                    }, delay * 60 * 1000);
                this.Refresh();

                this.visibleColumnIds = this.columnDefs.filter(a => a.colId && !a.hide).map(a => a.colId);

            },
            applyThresholdStyling(params, column)
            {          
                var selectedStyle = null;  
                if (this.threshold_rules)
                {
                    for (let i = this.threshold_rules.length - 1; i >= 0; i--) {                    
                        const threshold = this.threshold_rules[i];
                        if (threshold.id === column.ColId || (threshold.id == "datetime" && column.ColId == "starttime"))
                        {                  
                            switch(threshold.type)
                            {
                                case "set":
                                {
                                    var possibleSelectionIds = threshold.value;
                                    var columnLookups = {};
                                    if (column.lookups)
                                    {
                                        columnLookups = column.lookups;
                                    }
                                    var possibleSelections = possibleSelectionIds.map(key => columnLookups[key]);
                                    var selectedValue = params.value; 
                                    if (possibleSelectionIds.includes(selectedValue) || possibleSelections.includes(selectedValue))
                                    {
                                        var updatedStyle = this.generateThresholdStyle(threshold.color);
                                        if (updatedStyle)
                                        {
                                            selectedStyle = updatedStyle;
                                        }   
                                    }                              
                                    break;
                                }
                                case "date":
                                {
                                    var updatedStyle = this.selectThresholdStyle(threshold, params, threshold.type);       
                                    if (updatedStyle)
                                    {
                                        selectedStyle = updatedStyle;
                                    }                        
                                    break;
                                }
                                case "direction":
                                case "boolean":
                                {
                                    //Boolean and Direction columns Handled via CustomBooleanCellRenderer and cellRendererParams                            
                                break;
                                }
                                case "duration":
                                case "number":
                                case "percent":
                                {
                                    var updatedStyle = this.selectThresholdStyle(threshold, params, threshold.type);       
                                    if (updatedStyle)
                                    {
                                        selectedStyle = updatedStyle;
                                    }    

                                    break;
                                }
                                case "searchableText":
                                {
                                    var updatedStyle = this.selectThresholdStyle(threshold, params, threshold.type);       
                                    if (updatedStyle)
                                    {
                                        selectedStyle = updatedStyle;
                                    }    
                                    break;
                                }                    
                                default:
                                {
                                    console.log("We are in a different type of field!");
                                    console.log(threshold.type);
                                    break;
                                }
                            }
                        }
                    }
                }       
                return selectedStyle;
            },
            isValueMatch(operator, isValidValue, value, comparisonValue, isComparisonValueRelative, comparisonValueTo, isComparisonValueToRelative) {
                switch (operator) {
                    case "lessThan":  return isValidValue && (isComparisonValueRelative ? value > comparisonValue : value < comparisonValue);
                    case "lessThanOrEqualTo": return isValidValue && (isComparisonValueRelative ? value >= comparisonValue : value <= comparisonValue);
                    case "greaterThan": return isValidValue && (isComparisonValueRelative ? value < comparisonValue : value > comparisonValue);
                    case "greaterThanOrEqualTo": return isValidValue && (isComparisonValueRelative ? value <= comparisonValue : value >= comparisonValue);
                    case "equals": return value === comparisonValue;
                    case "notEquals": return value !== comparisonValue;
                    case "inRange": return isValidValue && ((value >= comparisonValue && value <= comparisonValueTo) || (value <= comparisonValue && value >= comparisonValueTo));
                    case "notInRange": return value <= comparisonValue || value >= comparisonValueTo;
                    case "missing": return !isValidValue;
                    case "contains": return isValidValue && value.includes(comparisonValue);
                    case "beginsWith": return isValidValue && value.startsWith(comparisonValue);
                    case "notContains": return !(isValidValue && value.includes(comparisonValue));
                    case "empty": return !isValidValue || value.length == 0;
                    case "notEmpty": return isValidValue && value.length > 0;
                    case "endsWith": return value.endsWith(comparisonValue);
                    default:
                        console.warn(`Unknown operator: ${operator}`);
                        return undefined; 
                }
            },
            selectThresholdStyle(threshold, params, columnType) {

                let value = Array.isArray(params.value) && threshold.type !== 'set' ? params.value.join(' ') : params.value;
                let comparisonValue = threshold.value;
                let comparisonValueTo = threshold.valueTo;
                let isComparisonValueRelative = false;
                let isComparisonValueToRelative = false;
                // let dataView = {
                //     value,
                //     comparisonValue,
                //     comparisonValueTo,
                //     isComparisonValueRelative,
                //     isComparisonValueToRelative,
                //     columnType
                // }
                // console.log(`Inside selectThresholdStyle: ${JSON.stringify(dataView)}`);

                if (columnType == "date")
                {
                    if (!this.isDate(comparisonValue))
                    {
                        comparisonValue = this.extractDateFromDateMath(comparisonValue);
                        isComparisonValueRelative = true;
                    }                    
                    if (!this.isDate(comparisonValueTo))
                    {
                        comparisonValueTo = this.extractDateFromDateMath(comparisonValueTo);
                        isComparisonValueToRelative = true;
                    }
                    if (value && value != 0)
                    {
                        value = new Date(value);
                    }
                    else 
                    {
                        if (threshold.operator == "empty" || threshold.operator == "missing") 
                        { 
                            return this.generateThresholdStyle(threshold.color); 
                        } 
                        else 
                        {
                           return null;
                        }
                    }
                    if (comparisonValue && comparisonValue != 0)
                    {
                        comparisonValue = new Date(comparisonValue);
                    }
                    if (comparisonValueTo && comparisonValueTo != 0)
                    {
                        comparisonValueTo = new Date(comparisonValueTo);
                    }
                    value = new Date(value).getTime();
                    comparisonValue =  new Date(comparisonValue).getTime();
                    comparisonValueTo =  new Date(comparisonValueTo).getTime();
                }
                
                let isValidValue = !!value || value === 0;
                
                let isMatched = this.isValueMatch(threshold.operator, isValidValue, value, comparisonValue, isComparisonValueRelative, comparisonValueTo, isComparisonValueToRelative);
                if (isMatched) {
                    return this.generateThresholdStyle(threshold.color);
                } else if (isMatched === undefined) {
                    console.warn(`Detected missing duration threshold logic for operator type: ${threshold.operator} ${JSON.stringify(threshold)}, v: ${value}, cv: ${comparisonValue},  cvt: ${comparisonValueTo}, icvr: ${isComparisonValueRelative}`);
                }

                return null; 
            },
            isDate(str) {
                if (typeof str !== 'string') {
                    return false;
                }
                const date = new Date(str);
                return !isNaN(date.valueOf());
            },
            extractDateFromDateMath(str){                              
                let currentDate = new Date(); 
                
                if (typeof str !== 'string' || !str) {
                    console.warn("Unable to extract date from date math string: " + str);
                    return ''; 
                }
                if (str === "now/" || str == "now")
                {
                    return new Date(currentDate.getTime());
                }

                const match = str.match(/now-(\d+)([dhsmwyM])/); 
                if (!match) {
                    console.warn("Unable to extract date from date math string: " + str);
                    return '';
                }

                const value = parseInt(match[1], 10);
                const unitIndicator = match[2]; 



      
                const newDate = new Date(currentDate.getTime());
                const operator = '-';

                // Apply the date math based on the unit and operator
                switch (unitIndicator) {
                    case 's': // seconds
                        newDate.setSeconds(newDate.getSeconds() + (operator === '-' ? -value : value));
                        break;
                    case 'm': // minutes
                        newDate.setMinutes(newDate.getMinutes() + (operator === '-' ? -value : value));
                        break;
                    case 'h': // hours
                        newDate.setHours(newDate.getHours() + (operator === '-' ? -value : value));
                        break;
                    case 'd': // days
                        newDate.setDate(newDate.getDate() + (operator === '-' ? -value : value));
                        break;
                    case 'w': // weeks (7 days)
                        newDate.setDate(newDate.getDate() + (operator === '-' ? -(value * 7) : (value * 7)));
                        break;
                    case 'M': // months (capital 'M' for months)
                        newDate.setMonth(newDate.getMonth() + (operator === '-' ? -value : value));
                        break;
                    case 'y': // years
                        newDate.setFullYear(newDate.getFullYear() + (operator === '-' ? -value : value));
                        break;
                    default:
                        // Handle unknown unit, though regex should prevent this if strict
                        return null;
                }
                return newDate;             
            },
            generateThresholdStyle(thresholdColor)
            {
                switch(thresholdColor)
                {
                    case "#4AB574": //Green
                    {
                        return { color: thresholdColor, "background-color": "#D9F8E5", fontWeight:500  };
                    }
                    case "#E07A1A": //Orange
                    {
                        return { color: thresholdColor, "background-color": "#FCEDDF", fontWeight:500  };
                    }
                    case "#EF4A41": //Red
                    {
                        return { color: thresholdColor, "background-color": "#F8E4E3", fontWeight:500  };
                    }
                    default:
                    return { color: thresholdColor, fontWeight:500 }
                }
            },
            applyInitialDateFilter() {
                if (this.ReadOnly && this.hasUserDateFilter) {
                    if ('starttime' in this.initial_column_filters || 'datetime' in this.initial_column_filters) {
                        const filter = this.initial_column_filters.starttime || this.initial_column_filters.datetime;
                        if (!filter) return;

                        if (filter.filter)
                            this.settings.startDate = common.getRelativeDateFromFilter(filter.filter);
                        else
                            this.settings.startDate = common.getRelativeDateFromFilter('now-0d/d'); // start of today

                        if (filter.filterTo)
                            this.settings.endDate = common.getRelativeDateFromFilter(filter.filterTo, true);
                        else
                            this.settings.endDate = common.getRelativeDateFromFilter('now', true); // start of tomorrow

                        this.settings.startDate = dayjs(this.settings.startDate).format("YYYY-MM-DDTHH:mm:ss.SSS");
                        this.settings.endDate = dayjs(this.settings.endDate).format("YYYY-MM-DDTHH:mm:ss.SSS");                            

                        this.defaultTime = JSON.stringify({ startDate: this.settings.startDate, endDate: this.settings.endDate });
                    }
                    else {
                        // Pre-populate the date range to be just today (no date filter specified, in view mode, that's the default)
                        let startDate = common.getRelativeDateFromFilter('now/d');
                        let endDate = common.getRelativeDateFromFilter('now', true);

                        this.settings.startDate = dayjs(startDate).format("YYYY-MM-DDTHH:mm:ss.SSS");
                        this.settings.endDate = dayjs(endDate).format("YYYY-MM-DDTHH:mm:ss.SSS");

                        this.defaultTime = JSON.stringify({ startDate: this.settings.startDate, endDate: this.settings.endDate });
                    }
                    console.log(`calendar Report setting initial defaultTime: ${this.defaultTime}`);
                }
            },
            async loadReportModel() {
                // Expects a model matching schema: Platform.Schema.Reports.v1.AggregateReport
                console.log('loadReportModel(); controlData:');
                console.log(JSON.stringify(this.controlData));

                let model;
                if (this.controlData.DataType == 'URL' && this.modelurl) {
                    try {
                        model = this.modelurlvalue ? await utils.api.get(this.modelurlvalue, false, false) : [];
                    }
                    catch (e) {

                        // SignalR backwards compatability
                        var statusCode = e.StatusCode ? e.StatusCode : e.statusCode;
                        var reasonPhrase = e.ReasonPhrase ? e.ReasonPhrase : e.reasonPhrase;

                        let msg = `Failed in API call to ${this.modelurlvalue}`;
                        utils.warn(`${this.type} ${this.name} ${msg}`, e);
                        msg = `API call failed: ${reasonPhrase}`;
                        this.EventBus.$emit('v-toast', {
                            text: 'Error',
                            subtext: e ? msg : 'Unknown error',
                            type: 'error',
                            icon: 'mdi mdi-alert',
                            ontap: [
                                {
                                    "PrimitiveAction": true,
                                    "ActionType": "DisplayConfirmModal",
                                    "RunAsync": false,
                                    "ActionData": {
                                        "OkayButtonText": "Okay",
                                        "CancelButtonText": "Cancel",
                                        "Debug": {},
                                        "Title": "Error " + (e ? statusCode : ''),
                                        "Message": `Failed in API call to ${this.modelurlvalue} - ${reasonPhrase}`
                                    }
                                }
                            ],
                            context: this,
                        });
                    }
                }
                else if (this.controlData.DataType == 'RawInterpolated' && this.modelvalue)
                    try {
                        model = this.modelrawvalue;

                        console.log(`model: ${JSON.stringify(model)}`);
                    }
                    catch (e) {
                        utils.warn('BasicGrid modelvalue ' + this.controlData.Data + ' failed to evaluate: ' + e);
                        model = {};
                    }
                else if (this.controlData.DataType == 'Raw' && this.controlData.Data)
                    model = this.controlData.Data;
                
                if (!model)
                    model = {};

                if (model.filters) {
                   
                    //Filter out columns that do not exist (may have been deleted)
                    model.filters = helps.toLookup(Object.keys(model.filters).filter(a =>
                        a in common.column_lookup ||
                        (a.indexOf('_agg') == a.length - 4 && a.substr(0, a.lastIndexOf('_', a.length - 5)) in common.column_lookup) ||
                        (a.indexOf('_value_count_agg') == a.length - "_value_count_agg".length && a.substr(0, a.indexOf('_value_count_agg'))) ||
                        (a.indexOf('_doc_count_agg') == a.length - "_doc_count_agg".length && a.substr(0, a.indexOf('_doc_count_agg')))              
                    ).map(a => ({ colId: a, value: model.filters[a] })), 'colId', 'value');
                    
                    var existingFilters = this.filter_settings;
                    this.filter_settings = model.filters;
                    this.column_filters = { ...model.filters }; // Used only to pre-initialize filters pane

                    if(!this.filter_settings.extralegtype && existingFilters.extralegtype){
                          this.filter_settings.extralegtype = existingFilters.extralegtype;
                          this.column_filters.extralegtype = existingFilters.extralegtype;
                    }


                    if (this.ReadOnly) {
                        this.initial_column_filters = _.cloneDeep(model.filters); // Used in ReadOnly to provide the base filter (for limited filtering, usage:2)

                        const filters = this.QueryString('report_filters') || this.Filters;
                        if (filters) {
                            const query_filters = JSON.parse(filters);
                            for (let key of Object.keys(query_filters)) {
                                if (key in this.initial_column_filters && this.initial_column_filters[key].usage) {
                                    // Only allow filters that have been allowed
                                    const filter = query_filters[key];

                                    // Merge together the default filter with the query string filter
                                    //this.initial_column_filters[key] = { ...this.initial_column_filters[key], ...filter };
                                    this.filter_settings[key] = { ...this.filter_settings[key], ...filter };
                                    this.column_filters[key] = { ...this.column_filters[key], ...filter };

                                    console.log(`-- this.column_filters[${key}]: ${JSON.stringify(this.column_filters[key],null,3)}`);
                                }
                            }
                        }

                        this.applyInitialDateFilter();
                    }
                }

                if (this.filter_settings.starttime || this.filter_settings.datetime)
                    this.useStartEnd = this.ReadOnly && this.hasUserDateFilter;

                if (model.report) {
                    this.report_settings = model.report;
                    this.datetime_interval = model.report.datetime_interval;

                    if (this.report_settings.groupby)
                        this.report_settings.groupby = this.report_settings.groupby.filter(a => a.colId in common.column_lookup);

                    if (this.report_settings.metrics)
                        this.report_settings.metrics = this.report_settings.metrics.filter(a => a.colId in common.column_lookup);

                    if (this.report_settings.pivoton && !(this.report_settings.pivoton in common.column_lookup))
                        this.report_settings.pivoton = '';                
                }

                
                if(model.thresholds){
                    this.threshold_rules = model.thresholds;
                    this.report_settings.thresholds = model.thresholds;
                }

                if (model.charting) {
                    this.customize_series = model.charting.series;
                    this.customize_axes = model.charting.axes;
                    this.custom_chart_options = model.charting.options;
                    this.custom_chart_legend = model.charting.legend;
                    this.chartMaxValues = model.charting.maxValues;
                    this.chartTypeSettings = model.charting.typeSettings;

                    // This is only used by the agGridToolReportChart component to initially load the settings
                    this.initial_chart_settings = {
                        ...model.charting,
                    };
                }

                if (model.columnstate) {
                    model.columnstate = model.columnstate.filter(a => a.colId in common.column_lookup || a.colId.includes('_agg'));

                    this.column_state = {
                        columnOrder: model.columnstate.map(a => a.colId),
                        columnSizing: model.columnstate.filter(a => a.width).map(a => ({ colId: a.colId, width: a.width })),
                        leftPinned: model.columnstate.filter(a => a.pinLeft).map(a => a.colId),
                        rightPinned: model.columnstate.filter(a => a.pinRight).map(a => a.colId),
                        sort: model.columnstate.filter(a => a.sort).map(a => ({ colId: a.colId, sort: a.sort })),
                    };
                }

                let stateobj = {};
                if (this.column_state && this.column_state.columnOrder) {
                    const invisiblecols = this.columnDefs.filter(a => a.colId && !this.column_state.columnOrder.includes(a.colId)).map(a => a.colId);
                    stateobj.columnOrder = {
                        orderedColIds: this.column_state.columnOrder.concat(invisiblecols)
                    };
                    if (this.column_state.columnSizing && this.column_state.columnSizing.length)
                        stateobj.columnSizing = {
                            columnSizingModel: this.column_state.columnSizing
                        };

                    if (this.column_state.sort && this.column_state.sort.length)
                        stateobj.sort = {
                            sortModel: this.column_state.sort,
                        };
                }

                //if (this.ReadOnly) {
                //    this.viewonly_settings = {
                //        column_picker_list: this.column_list.filter(a => this.column_state.columnOrder.includes(a.ColId)),
                //        //column_filter_list: this.column_list.filter(a => this.report_model.filters[a.ColId] && this.report_model.filters[a.ColId].usage),
                //    };
                //}

                console.log('setting initialState:');
                console.log(JSON.stringify(stateobj));

                this.initialState = stateobj;

                if ('display_type' in model)
                    this.default_display_type = this.display_type = model.display_type;

                console.log('about to applyTableReport(...)');

                if (this.report_settings)
                    this.applyTableReport(this.report_settings);
                else if (this.gridApi)
                    this.Refresh();
                else
                    this.refreshOnReady = true;

            },
            modelChanged() {
                // If the form model changes set the cc_form_changed_indicator
                if (this.notify_object) {
                    this.notify_object.formChanged();
                }
            },
            getWindowDimensions() {
                this.windowWidth = window.innerWidth;
                this.windowHeight = window.innerHeight;
            },
            updateDimensions() {
                const agchart = this.$refs.agchart;
                if (agchart) {
                    let canvas = agchart.$el.querySelector('canvas');
                    if (canvas) {
                        const parentDiv = canvas.parentNode;
                        if (parentDiv) {
                            const dx = window.innerWidth - this.windowWidth;
                            const dy = window.innerHeight - this.windowHeight;

                            console.log(`canvas was (${canvas.width},${canvas.height}) -> (${dx},${dy})`);

                            if (dx < 0) window.innerWidth += dx;
                            if (dy < 0) window.innerHeight += dy;
                            //if (dx < 0) canvas.width += dx;
                            //if (dy < 0) canvas.height += dy;

                            this.getWindowDimensions();
                        }
                        else
                            console.log('No parentNode found');
                    }
                    else
                        console.log('No canavs found');
                }
                else
                    console.log('No agchart found');
            },

            async Refresh() {
                if (this.query_in_progress) {
                    this.query_refresh_pending = true;
                    return;
                }

                if (this.gridApi && this.settings.startDate && this.settings.endDate) {
                    // After-key cursors are only valid for sequential pagination, so
                    // every refresh starts from the first block with a clean cache.
                    this.gridApi.ensureIndexVisible(0, 'top');
                    this.current_page = { from: 0, size: this.pageSize, after_key: null };
                    this.next_after_key = null;
                    this.total_rows = 0;
                    this.gridApi.refreshServerSide({ purge: true });
                }
                
            },

            async loadSourceTypes() {
                const res = await utils.api.get('Apps/Platform/Schema/AdvancedReports/v1/ReportingSources');
                try {
                    return res.SourceTypes.toSorted((a, b) => common.byField(a, b, 'DisplayName'));
                }
                catch (ex) {
                    console.error(ex.message);
                    return [];
                }
            },

            async loadCustomerList() {
                if (this.GlobalVars && this.GlobalVars.AllCustomers)
                    return common.remaplookup(this.GlobalVars.AllCustomers, 'Name');
                else {
                    const res = await utils.api.get('/Apps/ReportStudio/Utils/GetMyCustomerList');
                    return common.transformer(res, 'Name', 'CustomerID');
                }
            },
            async loadUserList() {
                if (this.GlobalVars && this.GlobalVars.AllUsers)
                    return common.remaplookup(this.GlobalVars.AllUsers, 'FullName');
                else if (this.GlobalVars && this.GlobalVars.Users)
                    return common.remaplookup(this.GlobalVars.Users, 'fullname');
                else {
                    const res = await utils.api.get('/Apps/ReportStudio/Utils/GetMyUserList');
                    return common.transformer(res, 'FullName', 'UserID');
                }
            },
            async loadChatTouchpoints() {
                const res = await utils.api.get('/Apps/Common/ChatTouchPoints');
                return common.transformer(res, 'Name', 'TouchPointID');
            },
            async loadColumns() {
                const columnlist = await utils.api.get('Apps/Platform/Schema/AdvancedReports/v1/Column/ListByID?OnlyMine=true');
                return columnlist;

                // Putting this on ice for now (7/26/24) - nice idea, not needed yet, adds a lot of complexity on the server
                //const morecols = [];
                //for (let c of columnlist) {
                //    if (c.DynamicColumn && c.DynamicColumn.ListAPI) {
                //        const dc = c.DynamicColumn;
                //        const promise = utils.api.get(dc.ListAPI);

                //        // Generate functions to evaluate the dynamic expressions
                //        const title_expn = new Function(dc.ListRowModelAs, `return ${dc.TitleExpression};`);
                //        const srcfld_expn = new Function(dc.ListRowModelAs, `return ${dc.SourceFieldExpression};`);
                //        const colid_expn = new Function(dc.ListRowModelAs, `return ${dc.ColIdExpression};`);

                //        const list = await promise;

                //        for (let x of list) {
                //            morecols.push({
                //                ...c,
                //                Title: title_expn(x),
                //                SourceField: srcfld_expn(x),
                //                ColId: colid_expn(x),
                //            });
                //        }
                //    }
                //}

                //return columnlist.concat(morecols);
            },
            async loadLookupTables() {
                try {
                    console.log(`_uid:${this._uid} loadLookupTables beginning...`);

                    const [sourcetypes, customerlist, userlist, chatlist, columnlist] = await Promise.all([
                        this.loadSourceTypes(),
                        this.loadCustomerList(),
                        this.loadUserList(),
                        this.loadChatTouchpoints(),
                        this.loadColumns(),
                    ]);

                    console.log(`_uid:${this._uid} loadLookupTables finished initial table loads`);

                    common.sourceTypes = helps.toLookup(sourcetypes, 'SourceName', 'DisplayName');
                    common.categories = helps.toLookup(categories, 'ID', 'Name');
                    common.customerLookup = customerlist;
                    common.userLookup = userlist;
                    common.chatLookup = chatlist;

                    // Grab the sets of columns by usage
                    this.column_list = columnlist;
                    common.column_lookup = helps.toLookup(this.column_list, 'ColId');

                    console.log(`_uid:${this._uid} loadLookupTables Lookups beginning...`);

                    const tasks = [];
                    for (let c of columnlist) {
                        if (c.MappingTableType == 'LookupAPI') {
                            tasks.push(common.loadLookup(c));
                        }
                        else if (c.MappingTableType == 'LookupList') {
                            c.lookups = helps.toLookup(c.MappingTable, 'Key', 'Value');
                        }
                    }

                    console.log(`_uid:${this._uid} loadLookupTables Lookups awaiting ${tasks.length} task(s)...`);

                    await Promise.all(tasks);

                    console.log(`_uid:${this._uid} loadLookupTables Lookups completed (${tasks.length} task(s))`);

                    // Generate the list of column definitions for ag-grid
                    let cols = columnlist.filter(a => a.SourceType).map(a => ({
                        colId: a.ColId,
                        field: a.SourceField,
                        headerName: a.Title,
                        type: a.SourceType,
                        hide: true,
                        suppressFiltersToolPanel: !a.ColumnUse.Filter,
                        menuTabs: ['generalMenuTab'],
                    })).toSorted((a, b) => common.byField(a, b, 'headerName'));

                    for (let i = 0; i < cols.length; i++) {
                        const row = cols[i];
                        if (row.colId == 'dispositions')
                            console.warn(`_uid:${this._uid} loadLookupTables dispositions type:${row.type}`);

                        if (row.type == 'textSetColumn' || row.type == 'phoneNumColumn') {
                            row.filterParams = {
                                values: this.getUniqueColValues(row.colId),
                                refreshValuesOnOpen: true
                            };
                            const c = common.column_lookup[row.colId];

                            if (row.colId == 'dispositions')
                                console.warn(`_uid:${this._uid} loadLookupTables dispositions column_lookup:${(c ? JSON.stringify(c) : 'unassigned')}`);

                            if (c && c.lookups) {
                                if (row.colId == 'dispositions')
                                    console.warn(`_uid:${this._uid} loadLookupTables dispositions assigning valueFormatter`);

                                row.valueFormatter = (v) => {
                                    if (typeof v.value === 'object' && Array.isArray(v.value))
                                        return v.value.map(a => c.lookups[a] || a).join(', ');
                                    else
                                        return c.lookups[v.value] || v.value;
                                }
                            }
                        }
                    }

                    console.log(`_uid:${this._uid} loadLookupTables finished generating columnDefs (${cols.length} column(s))`);

                    this.columnDefs = cols;
                }
                catch (ex) {
                    console.error(`_uid:${this._uid} Error in loadLookupTables: ${ex.message || ex.reasonPhrase}`);
                    this.queryError = ex.message || ex.reasonPhrase;
                }
            },
            RefreshAll() {
                this.applyTableReport(this.report_settings);
            },

            openadvancedsettings() {
                this.advancedSettingsVisible = true;
            },

            getColumnVisibility() {
                return this.columnVisibility;
            },
            getColumnDefs() {
                return this.columnDefs;
            },
            get_column_list() {
                return this.column_list;
            },

            /*

             When report options are changed from agGridToolReportFields, it invokes the notifyreportchange method
             which is defined above in the sideBar.toolPanels. This in turn calls applyTableReport which invokes
             either applyDynamicTableReport or applyFlatTableReport. If charting is visible, one of the chart methods
             generateXYChartOptions or generatePieChartOptions will be invoked to configure the chart axes and series.
             Following that, the columnDefs are altered based on the report's groupby and metrics selections. Finally,
             the Refresh method is called to tell ag-grid to refreshServerSide which triggers the dataSource.getRows
             which is defined above in the data section. Based upon the display type, either queryDynamicTable or queryFlatTable
             is invoked next. If a chart is being rendered, a within queryFlatTable, the resulting rows are passed through
             transformData to convert field types into their chart-compatible version.

             The sequence is thus:

             1. notifyreportchange
             2. applyTableReport
             3. applyDynamicTableReport or applyFlatTableReport
             4. (opt) generateXYChartOptions or generatePieChartOptions
             5. Refresh -> getRows
             6. queryDynamicTable or queryFlatTable
             7. (opt) transformData

            */

            updatechartserialization(chart) {

            },
            notifychartchange(series, axes, general_type, options, legend, maxValues, requery) {
                // This is fired by the agGridToolReportChart whenever a setting for the chart changes
                this.customize_series = [...series];
                this.customize_axes = [...axes];
                this.chartMaxValues = maxValues || 100;

                this.custom_chart_options = options || {};
                if (legend)
                    this.custom_chart_legend = legend;
                if (general_type)
                    this.chartTypeSettings = general_type;
                //this.applyTableReport(this.report_settings);

                const report = this.report_settings;
                const g1 = report.groupby[0];
                const col = this.columnDefs.find(c => (g1.colId == 'datetime' && c.colId == 'starttime') || c.colId == g1.colId);
                if (!col) return;

                // Grab all column definitions for each metric aggregation
                const mlist = report.metrics.map(m => ({ metric: m, colDef: this.columnDefs.find(c => c.colId == m.colId) }));

                // Generate axes and series for the chart
                if (this.chartTypeSettings.type == 'pie' || this.chartTypeSettings.type == 'donut')
                    this.generatePieChartOptions(col, mlist);
                else
                    this.generateXYChartOptions(col, mlist);

                console.log('customize_series:');
                console.log(JSON.stringify(this.customize_series,null,3));

                this.applyChartOptions(this.chartOptions.data, this.custom_chart_options, this.custom_chart_legend);

                if (requery)
                    this.Refresh();

                this.modelChanged();
            },
            notifychartrefresh(series, axes, general_type, options, legend) {
                // This is fired by the agGridToolReportChart in response to changes to the source which
                // do not affect the chart settings but that require a refresh of just the chart. If
                // we attempt to recalculate the chart via generateXYChartOptions, for example, it will
                // alter the chart series and trigger another notifychartrefresh, causing an infinite
                // loop. So in this case, we ONLY want to redraw the chart.

                this.customize_series = [...series];
                this.customize_axes = [...axes];
                this.custom_chart_options = options || {};
                if (legend)
                    this.custom_chart_legend = legend;
                if (general_type)
                    this.chartTypeSettings = general_type;

                console.log('customize_series:');
                console.log(JSON.stringify(this.customize_series, null, 3));

                this.applyChartOptions(this.chartOptions.data, this.custom_chart_options, this.custom_chart_legend);
            },
            notifyreportchange(report) {
                // This is triggered from the agGridToolReportFields.vue component whenever any
                // grouping fields or metrics change.
                console.log('report:');
                console.log(JSON.stringify(report, null, 3));

                if (this.gridApi)
                    this.gridApi.ensureIndexVisible(0, 'top');

                this.report_settings = report;
                this.datetime_interval = report.datetime_interval;

                this.System.LocalStorage(this.storageKey + '-dateinterval', this.datetime_interval);

                if (this.ChartIsDisabled && this.display_type == common.constants.DISPLAY_CHART)
                    this.display_type = common.constants.DISPLAY_FLAT_GRID;

                this.applyTableReport(report);

                this.modelChanged();
            },
            notifyThresholdsChanged(thresholds) {
                this.threshold_rules = thresholds;         
                this.report_settings.thresholds = this.threshold_rules; 
                this.applyTableReport(this.report_settings);
                  if(this.gridApi) {
                    this.gridApi.setGridOption('columnDefs', this.columnDefs);
                    this.Refresh();
                }
                else
                    this.refreshOnReady = true;
            },
            notifyfilterschanged(filters, colId) {
                console.log('notifyfilterschanged:');
                console.log(JSON.stringify(filters,null,3));

                if (!this.ReadOnly && (colId == 'starttime' || colId == 'datetime') && colId in filters) {
                    const f = filters[colId];
                    if (f.usage > 0) {
                        this.settings.startDate = common.getRelativeDateFromFilter(f.filter);
                        this.settings.endDate = common.getRelativeDateFromFilter(f.filterTo, true);
                        this.defaultTime = JSON.stringify({ startDate: this.settings.startDate, endDate: this.settings.endDate });

                        this.useStartEnd = false;
                    }
                }

                this.filter_settings = filters;
                this.Refresh();

                this.modelChanged();
            },

            applyTableReport(report) {
                switch (this.display_type) {
                    case common.constants.DISPLAY_DYNAMIC_GRID: // Dynamic Table
                        this.applyDynamicTableReport(report);
                        break;

                    case common.constants.DISPLAY_FLAT_GRID: // Flat Table
                    case common.constants.DISPLAY_CHART: // Chart
                        this.applyFlatTableReport(report);
                        break;
                }
            },
            applyDynamicTableReport(report) {
                if (!report || !report.groupby || !report.metrics || report.groupby.length < 1 || report.metrics.length < 1)
                    return;

                this.removeAutoGeneratedColumns();

                for (let i = 0; i < report.groupby.length; i++) {
                    const item = report.groupby[i];

                    // Only a single date/time column is needed. In the future,
                    // we'll decide which date/time column is used for each metric.
                    // In the meantime, they can change which date/time field is
                    // used in a general dropdown, but they can't select multiple
                    // date/time columns. (Doesn't make sense to select multiples
                    // for group by.)
                    if (item.colId == 'datetime') {
                        const dtcol = this.columnDefs.find(c => c.colId == 'starttime');
                        if (dtcol) {
                            dtcol.hide = true;
                            dtcol.rowGroup = true;
                            dtcol.rowGroupIndex = i;
                            continue;
                        }
                    }

                    const col = this.columnDefs.find(c => c.colId == item.colId);
                    if (!col) continue;

                    // The first column will always appear in the grouping column, so we hide the normal column
                    col.hide = true; // i == 0;
                    col.rowGroup = true;
                    col.rowGroupIndex = i;
                }

                const fields_used = {};
                for (let i = 0; i < report.metrics.length; i++) {
                    const item = report.metrics[i];
                    const col = this.columnDefs.find(c => c.colId == item.colId);
                    if (!col) continue;

                    // Show the metric column to allow drill-down visibility
                    col.hide = false;

                    const newtype = common.getAggregateColumnType(item.colId, item.function, col.type);
                    if (newtype != col.type || fields_used[col.field]) {
                        // Add a new special column just for aggregation, use a unique colId but the same field
                        const aggcol = {
                            colId: `${col.colId}_${item.function}_agg`,
                            field: `${col.colId}_${item.function}_agg`,
                            headerName: col.headerName,
                            hide: false,
                            type: newtype,
                            aggFunc: item.function,
                            suppressFiltersToolPanel: true,
                            cellStyle: (params) => this.applyThresholdStyling(params, { ColId: `${col.colId}_${item.function}_agg`, type: newtype })
                         };
                        this.columnDefs.push(aggcol);
                    }
                    else {
                        col.aggFunc = item.function;
                        fields_used[col.field] = true;
                    }
                }

                const changes = this.columnDefs.filter(a => a.aggFunc || a.rowGroup);
                console.log('changes:');
                console.log(JSON.stringify(changes, null, 3));

                //this.gridApi.applyColumnState({ state: changes });
                this.gridApi.setGridOption('columnDefs', this.columnDefs);
            },
            applyFlatTableReport(report) {
                if (!report.groupby || !report.metrics || report.groupby.length < 1 || report.metrics.length < 1)
                    return;

                // Charts can only have one group column and optionally one pivot column
                if (this.display_type == common.constants.DISPLAY_CHART && ((report.groupby.length > 1 && !report.pivoton) || report.groupby.length > 2))
                    return;

                if (this.query_in_progress) {
                    this.query_refresh_pending = true;
                    return;
                }

                this.removeAutoGeneratedColumns();

                // Remove any aggregation functions setup previously
                for (let i = 0; i < this.columnDefs.length; i++)
                    if (this.columnDefs[i].aggFunc)
                        delete this.columnDefs[i].aggFunc;

                //console.log('5');
                //console.log(JSON.stringify(this.columnDefs, null, 3));
                
                /*
                const g1 = report.groupby[0];
                const col = this.columnDefs.find(c => (g1.colId == 'datetime' && c.colId == 'starttime') || c.colId == g1.colId);
                if (!col) return;

                // Grab all column definitions for each metric aggregation
                const mlist = report.metrics.map(m => ({ metric: m, colDef: this.columnDefs.find(c => c.colId == m.colId) }));
                //console.log('mlist:');
                //console.log(JSON.stringify(mlist));

                // Generate axes and series for the chart
                if (this.chartTypeSettings.type == 'pie' || this.chartTypeSettings.type == 'donut')
                    this.generatePieChartOptions(col, mlist);
                else
                    this.generateXYChartOptions(col, mlist);
                */

                // Make visible all columns used for grouping
                for (let i = 0; i < report.groupby.length; i++) {
                    const item = report.groupby[i];

                    // Only a single date/time column is needed. In the future,
                    // we'll decide which date/time column is used for each metric.
                    // In the meantime, they can change which date/time field is
                    // used in a general dropdown, but they can't select multiple
                    // date/time columns. (Doesn't make sense to select multiples
                    // for group by.)
                    //if (item.colId == 'datetime') {
                    //    const dtcol = this.columnDefs.find(c => c.colId == 'starttime');
                    //    if (dtcol) {
                    //        dtcol.hide = false;
                    //        //dtcol.rowGroup = false;
                    //        dtcol.field = dtcol.colId;

                    //        // Special type selection for Day of Week and Hour of Day
                    //        if (report.datetime_interval == 'dow')
                    //            dtcol.type = 'dayOfWeekColumn';
                    //        else if (report.datetime_interval == 'hod')
                    //            dtcol.type = 'hourOfDayColumn';
                    //        else if (report.datetime_interval == 'dowhod')
                    //            dtcol.type = 'dowAndHodColumn';
                    //        else
                    //            dtcol.type = 'dateColumn';

                    //        if (this.column_state.columnSizing) {
                    //            const s = this.column_state.columnSizing.find(a => a.colId == dtcol.colId);
                    //            if (s)
                    //                dtcol.width = s.width;
                    //        }

                    //        continue;
                    //    }
                    //}

                    const col = this.columnDefs.find(c => c.colId == (item.colId == 'datetime' ? 'starttime' : item.colId));
                    if (!col) continue;

                    col.hide = false;
                    //col.rowGroup = false;
                    col.field = col.colId;

                    if (item.colId == 'datetime' || col.type == 'dayOfWeekColumn' || col.type == 'hourOfDayColumn' || col.type == 'halfHourOfDayColumn' || col.type == 'dateColumn') {
                        // Special type selection for Day of Week and Hour of Day
                        if (report.datetime_interval == 'dow')
                            col.type = 'dayOfWeekColumn';
                        else if (report.datetime_interval == 'hod')
                            col.type = 'hourOfDayColumn';
                        else if (report.datetime_interval == 'h30od')
                            col.type = 'halfHourOfDayColumn';
                        else if (report.datetime_interval == 'dowhod')
                            col.type = 'dowAndHodColumn';
                        else
                            col.type = 'dateColumn';
                    }

                    if (this.column_state.columnSizing) {
                        const s = this.column_state.columnSizing.find(a => a.colId == col.colId);
                        if (s)
                            col.width = s.width;
                    }

                    col.pinned = 'left';
                    col.lockPinned = true;
                    col.suppressMovable = !!report.pivoton;
                    col.lockVisible = true;
                    col.suppressFiltersToolPanel = true;
                }

                for (let i = 0; i < report.metrics.length; i++) {
                    const item = report.metrics[i];
                    const col = this.columnDefs.find(c => c.colId == item.colId);
                    if (!col) continue;

                    // Hide the base metric column since all aggregate metrics will be auto-generated
                    // (unless it's used for grouping, then don't hide)
                    col.hide = !report.groupby.some(g => g.colId == col.colId || (g.colId == 'datetime' && col.colId == 'starttime'));

                    let newtype = common.getAggregateColumnType(item.colId, item.function, col.type);

                    // Add a new special column just for aggregation, use a unique colId but the same field
                    const aggcol = {
                        colId: `${col.colId}_${item.function}_agg`,
                        field: `${col.colId}_${item.function}_agg`,
                        headerName: common.formatHeader({ type: newtype, headerName: col.headerName, aggFunc: item.function }),
                        tooltipField: '_tooltipvalue',
                        hide: false,
                        type: newtype,
                        suppressFiltersToolPanel: true,
                        aggFunc: item.function,
                        menuTabs: ['generalMenuTab'],
                        cellStyle: (params) => this.applyThresholdStyling(params, { ColId: `${col.colId}_${item.function}_agg`, type: newtype }),
                        lockVisible: true
                     };

                    if (this.column_state.columnSizing) {
                        const s = this.column_state.columnSizing.find(a => a.colId == aggcol.colId);
                        if (s)
                            aggcol.width = s.width;
                    }

                    this.columnDefs.push(aggcol);
                }

                //const changes = this.columnDefs.filter(a => !a.hide);
                //console.log('changes:');
                //console.log(JSON.stringify(changes, null, 3));

                if(this.gridApi) {
                    this.gridApi.setGridOption('columnDefs', this.columnDefs);
                    this.Refresh();
                }
                else
                    this.refreshOnReady = true;
            },
            
            applyChartSelection(chart) {
                // This is invoked by the dropdown list to change chart types
                this.chartTypeSettings = chart;
                this.applyTableReport(this.report_settings);
                this.Refresh();
            },
            applyChartOptions(data, options, legend) {
                if (this.preparedChartOptions) {
                    let legendFormatter = legend.suppress_metric_suffix ? this.legendFormatterNoSuffix : this.legendFormatter;

                    if (this.report_settings.pivoton) {
                        let pivotcol = common.column_lookup[this.report_settings.pivoton];
                        if (pivotcol) {
                            switch (pivotcol.SourceType) {
                                case 'userIDColumn':
                                    legendFormatter = this.getLegendFormatter(common.userLookup, legend.suppress_metric_suffix);
                                    break;

                                case 'customerIDColumn':
                                    legendFormatter = this.getLegendFormatter(common.customerLookup, legend.suppress_metric_suffix);
                                    break;

                                case 'textSetColumn':
                                    if (pivotcol.lookups)
                                        legendFormatter = this.getLegendFormatter(pivotcol.lookups, legend.suppress_metric_suffix);
                                    break;

                                case 'channelTypeColumn':
                                    legendFormatter = legend.suppress_metric_suffix ? this.legendChannelTypeFormatterNoSuffix : this.legendChannelTypeFormatter;
                                    break;
                            }
                        }
                    }

                    const axes = this.customizeAxes(this.preparedChartOptions.axes, this.pivot_columns);
                    this.applyChartDateTicks(axes, data);

                    this.chartOptions = {
                        theme: this.chartTheme,
                        zoom: {
                            enableSelecting: true,
                        },
                        legend: {
                            enabled: true,
                            position: legend.position,
                            item: {
                                label: { formatter: legendFormatter },
                                showSeriesStroke: legend.showSeriesStroke,
                            },
                        },
                        ...options,
                        axes: axes,
                        series: this.customizeSeries(this.preparedChartOptions.series, this.pivot_columns),
                        data: data,
                    };
                }
            },
            applyChartDateTicks(axes, data) {
                if (this.report_settings?.datetime_interval != 'month')
                    return;

                const values = [...new Set(data
                    .map(row => row.starttime)
                    .filter(value => value != null))];
                if (!values.length)
                    return;

                for (let axis of axes)
                    if (axis.type == 'ordinal-time') {
                        axis.tick = { ...axis.tick, values };
                        axis.label = { ...axis.label, avoidCollisions: false };
                    }
            },
            generatePieChartOptions(groupcol, metric_list) {
                const axes = [];
                const series = [];
                const transformer = [];

                const groupcolId = groupcol.colId == 'datetime' ? 'starttime' : groupcol.colId;

                // Figure out the pie item label's type
                switch (groupcol.type) {
                    case 'dayOfWeekColumn':
                    case 'hourOfDayColumn':
                    case 'halfHourOfDayColumn':
                    case 'dowAndHodColumn':
                    case 'dateColumn':
                        switch (this.report_settings.datetime_interval) {
                            case 'dow':
                                transformer.push({
                                    colId: groupcolId,
                                    transform: (row) => row[groupcolId].substring(1)
                                });
                                break;
                            case 'hod':
                                transformer.push({
                                    colId: groupcolId,
                                    transform: (row) => row[groupcolId]
                                });
                                break;
                            case 'h30od':
                                transformer.push({
                                    colId: groupcolId,
                                    transform: (row) => row[groupcolId]
                                });
                                break;
                            case 'dowhod':
                                transformer.push({
                                    colId: groupcolId,
                                    transform: (row) => row[groupcolId].substring(1)
                                });
                                break;
                            default:
                                transformer.push({
                                    colId: groupcolId,
                                    transform: (row) => this.chartDateLabel(row[groupcolId]),
                                });
                                break;
                        }
                        break;

                    case 'customerIDColumn':
                        transformer.push({ colId: groupcolId, transform: (row) => common.customerLookup[row[groupcolId]] || 'Unknown' });
                        break;

                    case 'userIDColumn':
                        transformer.push({ colId: groupcolId, transform: (row) => common.userLookup[row[groupcolId]] || 'Unknown' });
                        break;

                    case 'textSetColumn':
                    case 'searchableTextColumn':
                        const col = common.column_lookup[groupcolId];

                        if (col && col.lookups)
                            transformer.push({ colId: groupcolId, transform: (row) => col.lookups[row[groupcolId]] || row[groupcolId] });
                        else
                            transformer.push({ colId: groupcolId, transform: (row) => row[groupcolId] });
                        break;


                    default:
                        transformer.push({ colId: groupcolId, transform: (row) => row[groupcolId] });
                        break;
                }

                // Only the first metric can be shown in a pie, but a donut can have multiples
                let r0 = 0.3;
                for (let i = 0; i < metric_list.length; i++) {
                    const item = metric_list[i];
                    const field = `${item.metric.colId}_${item.metric.function}_agg`;
                    const s = {
                        ...this.chartTypeSettings,
                        angleKey: field,
                      //legendItemKey: groupcolId,
                        title: { text: item.colDef.headerName, showInLegend: true },
                        sectorLabelKey: field,
                        calloutLabelKey: groupcolId,
                    };
                    if (s.type == 'donut') {
                        s.innerRadiusRatio = r0;
                        r0 += 1 / metric_list.length / 2; if (r0 > 1) r0 = 1;

                        if (s.type == 'donut')
                            s.outerRadiusRatio = r0;

                        r0 += 1 / metric_list.length / 4; if (r0 > 1) r0 = 1;
                    }

                    series.push(s);

                    const type = common.getAggregateColumnType(item.metric.colId, item.metric.function, item.colDef.type);
                    switch (type) {
                        case 'percentColumn':
                            transformer.push({ colId: field, transform: (row) => Math.round(row[field] * 100) });
                            break;

                        case 'userIDColumn':
                            transformer.push({ colId: field, transform: (row) => common.userLookup[row[field]] || 'Unknown' });
                            break;

                        default:
                            transformer.push({ colId: field, transform: (row) => row[field] });
                            break;
                    }
                }

                console.log('series:');
                console.log(JSON.stringify(series));

                this.preparedChartOptions = {
                    axes: axes,
                    series: series,
                    transformer: transformer,
                };
            },
            generateXYChartOptions(groupcol, metric_list) {
                const axes = [];
                const series = [];
                const transformer = [];

                //console.log('generateXYChartOptions groupcol:');
                //console.log(JSON.stringify(groupcol));

                let xaxis_position = 'bottom';
                let yaxis_position = ['left', 'right'];
                if (this.chartTypeSettings.direction == 'horizontal') {
                    xaxis_position = 'left';
                    yaxis_position = ['bottom', 'top'];
                }

                const groupcolId = groupcol.colId == 'datetime' ? 'starttime' : groupcol.colId;

                // Create the X axis as a date
                switch (groupcol.type) {
                    case 'dayOfWeekColumn':
                    case 'hourOfDayColumn':
                    case 'halfHourOfDayColumn':
                    case 'dowAndHodColumn':
                    case 'dateColumn':
                        switch (this.report_settings.datetime_interval) {
                            case 'dow':
                                axes.push({ type: 'category', position: xaxis_position, tick: {}, title: { text: 'Day of Week' }, label: {}, crosshair: {label: { renderer: this.formattedDateCrosshairLabel}} });
                                transformer.push({
                                    colId: groupcolId,
                                    transform: (row) => row[groupcolId].substring(1)
                                });
                                break;

                            case 'hod':
                                axes.push({ type: 'number', position: xaxis_position, tick: {}, title: { text: 'Hour of Day' }, label: {}, crosshair: {label: { renderer: this.formattedDateCrosshairLabel}} });
                                transformer.push({
                                    colId: groupcolId,
                                    transform: (row) => parseInt(row[groupcolId])
                                });
                                break;

                            case 'h30od':
                                axes.push({ type: 'category', position: xaxis_position, tick: {}, title: { text: 'Half Hour of Day' }, label: {}, crosshair: {label: { renderer: this.formattedDateCrosshairLabel}} });
                                transformer.push({
                                    colId: groupcolId,
                                    transform: (row) => row[groupcolId]
                                });
                                break;

                            case 'dowhod':
                                axes.push({ type: 'category', position: xaxis_position, tick: {}, title: { text: 'Day of Week & Hour of Day' }, label: {}, crosshair: {label: { renderer: this.formattedDateCrosshairLabel}} });
                                transformer.push({
                                    colId: groupcolId,
                                    transform: (row) => row[groupcolId].substring(1)
                                });
                                break;

                            default:
                                axes.push({ type: 'ordinal-time', position: xaxis_position, tick: {}, title: { text: 'Date/Time' }, label: {}, crosshair: {label: { renderer: this.formattedDateCrosshairLabel}} });
                                transformer.push({
                                    colId: groupcolId,
                                    transform: (row) => this.chartDateValue(row[groupcolId])
                                });
                                break;
                        }
                        break;

                    case 'channelTypeColumn':
                    case 'textSetColumn':
                    case 'searchableTextColumn':
                        const col = common.column_lookup[groupcolId];

                        axes.push({ type: 'category', position: xaxis_position, tick: {}, title: { text: groupcol.headerName }, label: {} });

                        if (col && col.lookups)
                            transformer.push({ colId: groupcolId, transform: (row) => col.lookups[row[groupcolId]] || row[groupcolId] });
                        else
                            transformer.push({ colId: groupcolId, transform: (row) => row[groupcolId] });
                        break;

                    case 'phoneNumColumn':
                        axes.push({ type: 'category', position: xaxis_position, tick: {}, title: { text: groupcol.headerName }, label: {} });
                        transformer.push({
                            colId: groupcolId,
                            transform: (row) => this.phoneNumLookupFormatter({
                                data: row,
                                value: row[groupcolId] || 'Unknown'
                            })
                        });
                        break;

                    case 'customerIDColumn':
                        axes.push({ type: 'category', position: xaxis_position, tick: {}, title: { text: groupcol.headerName }, label: {} });
                        transformer.push({ colId: groupcolId, transform: (row) => common.customerLookup[row[groupcolId]] || 'Unknown' });
                        break;

                    case 'userIDColumn':
                        axes.push({ type: 'category', position: xaxis_position, tick: {}, title: { text: groupcol.headerName }, label: {} });
                        transformer.push({ colId: groupcolId, transform: (row) => common.userLookup[row[groupcolId]] || 'Unknown' });
                        break;

                    case 'countColumn':
                    case 'floatColumn':
                        axes.push({ type: 'number', position: xaxis_position, tick: {}, title: { text: groupcol.headerName }, label: {} });
                        transformer.push({ colId: groupcolId, transform: (row) => row[groupcolId] });
                        break;

                    case 'durationColumn':
                        axes.push({
                            type: 'number', position: xaxis_position,
                            title: { text: groupcol.headerName },
                            tick: {},
                            label: { formatter: (p) => helps.durationSecondsAsStringWithHours(parseFloat(p.value)) }
                        });
                        transformer.push({ colId: groupcolId, transform: (row) => row[groupcolId] });
                        break;
                }

                // Get a unique list of metric types (countColumn, durationColumn, percentColumn) and create a Y axis for it
                const types = [...new Set(metric_list.map(m => common.getAggregateColumnType(m.metric.colId, m.metric.function, m.colDef.type)))];
                //console.log('types:');
                //console.log(JSON.stringify(types));

                // Get a list of each metric associated with each unique type
                const mset = {};
                for (let item of types.map(t => ({ type: t, metrics: metric_list.filter(m => t == common.getAggregateColumnType(m.metric.colId, m.metric.function, m.colDef.type)) }))) {
                    mset[item.type] = item.metrics.map(m => `${m.colDef.colId}_${m.metric.function}_agg`);
                }
                //console.log('mset:');
                //console.log(JSON.stringify(mset));

                // Create an axis for each unique metric type, up to all four (count,duration,percent,currency).
                for (let type of types) {
                    switch (type) {
                        case 'countColumn':
                        case 'floatColumn':
                            axes.push({
                                type: 'number',
                                position: axes.length > 1 ? yaxis_position[1] : yaxis_position[0],
                                title: { text: 'Count' },
                                tick: {},
                                label: {},
                                keys: mset[type],
                                min: 0
                            });
                            break;

                        case 'durationColumn':
                            axes.push({
                                type: 'number', 
                                position: axes.length > 1 ? yaxis_position[1] : yaxis_position[0],
                                title: { text: 'Duration' },
                                tick: {},
                                crosshair: {label: { renderer: this.durationCrosshairLabel}},
                                label: { formatter: (p) => this.durationFormattedString(parseFloat(p.value))},
                                keys: mset[type],
                                min: 0
                            });
                            break;

                        case 'percentColumn':
                            axes.push({
                                type: 'number', position: axes.length > 1 ? yaxis_position[1] : yaxis_position[0],
                                title: { text: 'Percent' },
                                tick: {},
                                label: { formatter: (p) => p.value + '%' },
                                keys: mset[type],
                                min: 0
                            });
                            break;

                        case 'currencyColumn':
                            axes.push({
                                type: 'number', position: axes.length > 1 ? yaxis_position[1] : yaxis_position[0],
                                title: { text: 'Amount' },
                                tick: {},
                                label: { formatter: (p) => this.f_currency(parseFloat(p.value)) },
                                keys: mset[type],
                                min: 0
                            });
                            break;
                    }
                }
                //format: '#{0>1.0}%',

                //console.log('axes:');
                //console.log(JSON.stringify(axes));

                for (let item of metric_list) {
                    let type = common.getAggregateColumnType(item.metric.colId, item.metric.function, item.colDef.type);

                    const field = `${item.metric.colId}_${item.metric.function}_agg`;
                    const tooltip = { renderer: this.defaultTooltip};
                    const s = { tooltip, ...this.chartTypeSettings, xKey: groupcolId, yKey: field };

                    // Tell the chart to only stack like-typed metrics, different types will be in a different group
                    if ((s.type == 'bar' || s.type == 'area') && s.stacked)
                        s.stackGroup = type;

                    //const type = common.getAggregateColumnType(item.metric.function, item.colDef.type);
                    switch (type) {
                        case 'percentColumn':
                            transformer.push({ colId: field, transform: (row) => Math.round(row[field] * 100) });
                            break;

                        case 'userIDColumn':
                            transformer.push({ colId: field, transform: (row) => common.userLookup[row[field]] || 'Unknown' });
                            break;
                        
                        case 'durationColumn':
                            s.tooltip = { renderer: this.durationTooltip };
                            transformer.push({ colId: field, transform: (row) => row[field] });
                            break;

                        default:
                            transformer.push({ colId: field, transform: (row) => row[field] });
                            break;
                    }

                    series.push(s);

                }

                if (this.pivot_columns) {
                    // Create new series for each pivot column, which is generated by the results of the query
                    for (let field of this.pivot_columns) {
                        const child = field.split(common.constants.PIVOT_HEADER_SEP)[1];
                        const axis = axes.find(a => a.keys && a.keys.includes(child));
                        if (axis)
                            axis.keys.push(field);

                        const s = {
                            ...this.chartTypeSettings,
                            xKey: groupcolId,
                            yKey: field,
                        };

                        // Tell the chart to only stack like-typed metrics, different types will be in a different group
                        if ((s.type == 'bar' || s.type == 'area') && s.stacked)
                            s.stackGroup = field.split(common.constants.PIVOT_HEADER_SEP)[1];

                        series.push(s);

                        transformer.push({ colId: field, transform: (row) => row[field] });
                    }

                    // Grab a unique list of all unique metrics coming from the pivotted data
                    const baseseries = [...new Set(this.pivot_columns.map(a => a.split(common.constants.PIVOT_HEADER_SEP)[1]))];

                    // Filter out the base metrics from the axes and series
                    for (let s of baseseries) {
                        for (let idx = axes.findIndex(a => a.keys && a.keys.includes(s)); idx >= 0; idx = axes.findIndex(a => a.keys && a.keys.includes(s)))
                            axes[idx].keys.splice(axes[idx].keys.indexOf(s), 1);

                        for (let idx = series.findIndex(a => a.yKey == s); idx >= 0; idx = series.findIndex(a => a.yKey == s))
                            series.splice(idx, 1);
                    }
                }

                console.log('axes:');
                console.log(JSON.stringify(axes, null, 3));

                console.log('series:');
                console.log(JSON.stringify(series,null,3));

                this.preparedChartOptions = {
                    axes: axes,
                    series: series,
                    transformer: transformer,
                };
            },

            defaultTooltip({ datum, xKey, yKey }) {
                let tooltipContent = '';
                const date = new Date(datum[xKey]);
                if(!isNaN(date.getTime())) {
                    tooltipContent = `${this.dateFormatter(date)}`;
                } else
                    tooltipContent = datum[xKey];

                tooltipContent += `: ${datum[yKey]}`;

                return {
                    content: tooltipContent
                };
            },
            
            durationTooltip({ datum, xKey, yKey }) {
                let yLabel = this.durationFormattedString(datum[yKey]);
                let tooltipContent = '';
                const date = new Date(datum[xKey]);
                if(!isNaN(date.getTime())) {
                    tooltipContent = `${this.dateFormatter(date)}`;
                } else
                    tooltipContent = datum[xKey];

                tooltipContent += `: ${yLabel}`;

                return {
                    content: tooltipContent
                };
            },

            formattedDateCrosshairLabel({ value, fractionDigits }) {
                let crosshairText = value;
                const date = new Date(value);
                if(!isNaN(date.getTime())) 
                    crosshairText =  `${this.dateFormatter(date)}`;
            
                return {
                    text: crosshairText
                }
            },

            durationCrosshairLabel({ value, fractionDigits }) {
                let crosshairText = this.durationFormattedString(value);
                
                return {
                    text: crosshairText
                };
            },

            durationFormattedString(value) {
                let seconds = value;
                let result = "";
                if (isNaN(parseFloat(seconds)))
                    result = value;
                else {
                    // Round the input seconds to the nearest whole number
                    seconds = Math.round(seconds);
                    switch (this.durationFormat) {
                        case 'HH:MM:SS':
                            let neg = false;
                            if (seconds < 0) {
                                seconds = -seconds;
                                neg = true;
                            }
                            seconds = Math.floor(seconds);

                            let hours = Math.floor(seconds / (60 * 60));
                            seconds = seconds - (hours * 60 * 60);

                            let minutes = Math.floor(seconds / 60);
                            seconds = seconds - (minutes * 60);

                            if (hours)
                                result = ((hours <= 9) ? "0" : "") + hours + ":" + ((minutes <= 9) ? "0" : "") + minutes + ":" + ((seconds <= 9) ? "0" : "") + seconds;
                            else if (minutes)
                                result = ((minutes <= 9) ? "0" : "") + minutes + ":" + ((seconds <= 9) ? "0" : "") + seconds;
                            else if (seconds)
                                result = "00:" + ((seconds <= 9) ? "0" : "") + seconds;
                            else
                                result = "00:00";

                            if (neg) result = `-${result}`;
                            break;

                        case 'Minutes':
                            result = (seconds / 60).toFixed(2);
                            break;

                        case 'Seconds':
                        default:
                            result = seconds.toFixed(0);
                            break;
                    }
                }

                return result;
            },

            removeAutoGeneratedColumns() {
                // Remove all previously configured auto-generated aggregation columns
                for (let i = this.columnDefs.length - 1; i >= 0; i--) {
                    const item = this.columnDefs[i];
                    //console.log(`*** *** *** colId:${item.colId}`);

                    if (item.colId.indexOf('_agg') >= 0) {
                        //console.log(`*** *** *** colId:${item.colId}; item.colId.indexOf('_agg'):${item.colId.indexOf('_agg')} == item.colId.length-4:${item.colId.length - 4}`);
                        if (item.colId.indexOf('_agg') == item.colId.length - 4)
                            this.columnDefs.splice(i, 1);
                    }
                    else if (item.colId.substring(0,6) == 'pivot_')
                        this.columnDefs.splice(i, 1);

                    item.hide = true;
                }
            },

            async queryDynamicTable(params) {
                // When using rowGroup:
                // {"startRow":0,"endRow":100,"rowGroupCols":[{"id":"direction","displayName":"Direction","field":"direction"}],"valueCols":[],"pivotCols":[],"pivotMode":false,"groupKeys":["inbound"],"filterModel":{},"sortModel":[]}
                const q_from = this.using_aggs ? 0 : params.startRow;
                const q_size = this.using_aggs ? common.pageSize : (params.endRow - params.startRow);

                let dataurl = `${common.buildRequest(this.baseurl, this.settings.startDate, this.settings.endDate)}&PageSize=${q_size}&From=${q_from}`;

                if (params.sortModel && params.sortModel.length) {
                    dataurl += `&SortCol=${params.sortModel[0].colId}&Descending=${params.sortModel[0].sort == 'desc'}`;
                    dataurl += `&sortModel=${JSON.stringify(params.sortModel)}`;
                }

                if (params.filterModel) {
                    dataurl += '&filters=' + encodeURIComponent(JSON.stringify(params.filterModel));
                    console.log('filterModel: ' + JSON.stringify(params.filterModel));
                }

                // rowGroups: determines which columns to aggregate by
                dataurl += '&rowGroups=' + encodeURIComponent(JSON.stringify(params.rowGroupCols || [])) + '&groupKeys=' + encodeURIComponent(JSON.stringify(params.groupKeys || []));

                // valueCols: determines which columns are the values for the aggregations (skip columns auto-generated as "count" fields which always come regardless)
                if (params.valueCols && params.valueCols.length) {
                    let valueCols = params.valueCols.filter(a => a.id != 'count');
                    if (this.customMetrics)
                        valueCols = valueCols.filter(a => this.customMetrics[this.remove_count(a.id)] === undefined);
                    dataurl += '&valueCols=' + encodeURIComponent(JSON.stringify(valueCols));
                }
                else
                    dataurl += '&valueCols=[]';

                // pivotCols: determines what columns are being pivoted to generate new columns from distinct row values
                dataurl += '&pivotCols=' + encodeURIComponent(JSON.stringify(params.pivotCols || []));

                // customMetrics: additional values to use for aggregations with optional filters. The metric function is determined by the function specified in the valueCols.
                if (this.customMetrics) {
                    let cmstr = JSON.stringify(this.customMetrics);
                    for (let i = 0; i < params.valueCols.length; i++) {
                        const vf = params.valueCols[i];
                        let func = vf.aggFunc;
                        if (func == 'count') func = 'value_count';
                        cmstr = cmstr.replace(`_func_${vf.id}`, func);
                    }

                    dataurl += '&customMetrics=' + encodeURIComponent(cmstr);
                }

                //if (this.using_aggs && this.after_key)
                //    dataurl += '&after_key=' + encodeURIComponent(this.after_key);

                dataurl += '&IndexName=' + this.active_source;

                console.log('url: ' + dataurl.split('&').join('\n'));

                const res = await utils.api.get(dataurl);

                console.log(`get returned ${res && res.rows ? res.rows.length : 0} row(s)`);

                //this.after_key = res.after_key;
                this.query_duration = res.took;
                this.total_rows = res.append ? (this.total_rows + res.total) : res.total;
                this.using_aggs = res.aggs;

                if (res.append && res.total === 0) {
                    const output = {
                        rowData: res.rows,
                        rowCount: this.total_rows,
                    };
                    console.log(`----- Appending ${output.rowData.length} rows, rowCount:${output.rowCount}`);
                    return output;
                }

                //gridApi.setColumnsVisible('count', res.Result.aggs);
                // api.setColumnsVisible([colKey], visible)
                //columnDefs.value[columnDefs.value.length - 1].hide = !res.Result.aggs; // Make the "count" column visible if the result includes aggregations

                if (res.pivotDefs && res.pivotDefs.length) {
                    //server.api.setPivotResultColumns(res.Result.pivotDefs);
                    const output = {
                        rowData: res.rows,
                        rowCount: res.total,
                        pivotResultFields: res.pivotDefs
                    };
                    console.log(`----- Returning ${output.rowData.length} rows, rowCount:${output.rowCount}, pivotResultFields:${output.pivotResultFields.length}`);

                    return output;
                }
                else {
                    const output = {
                        rowData: res.rows,
                        rowCount: this.total_rows,
                        //rowCount: res.after_key ? (this.total < 100 ? this.total_rows : (this.total_rows + 1)) : this.total_rows,
                    };
                    console.log(`----- Returning ${output.rowData.length} rows, rowCount:${output.rowCount}`);

                    return output;
                }
            },
            async queryFlatTable(params) {
                const q_from = this.display_type < common.constants.DISPLAY_CHART ? params.startRow : 0;
                const q_size = this.display_type < common.constants.DISPLAY_CHART ? (params.endRow - params.startRow) : this.chartMaxValues;

                // Only when we are advancing to another page and we have saved a next after key should we update the after key for this next query
                if (q_from === 0)
                    this.current_page.after_key = null;
                else if (q_from > this.current_page.from && this.next_after_key)
                    this.current_page.after_key = this.next_after_key;

                this.current_page.from = q_from;
                this.current_page.size = q_size;

                let dataurl = `${common.buildRequest('', this.settings.startDate, this.settings.endDate)}&From=${q_from}&PageSize=${q_size}&PresortSize=${common.presortSize}&interval=${this.datetime_interval}`;

                if (this.useStartEnd)
                    dataurl += '&UseStartEnd=true';

                if (this.current_page.after_key)
                    dataurl += `&after_key=${encodeURIComponent(this.current_page.after_key)}`;

                if (params.sortModel && params.sortModel.length)
                    dataurl += `&sortModel=${JSON.stringify(params.sortModel)}`;

                if (params.filterModel) {
                    // Mix the ag-grid filter settings with the newer custom filter settings from agGridToolReportFilters.vue
                    const f = { ...this.filter_settings, ...params.filterModel };
                    dataurl += '&filters=' + encodeURIComponent(JSON.stringify(f));
                    console.log('filterModel: ' + JSON.stringify(f));
                }

                if (!this.report_settings.groupby || !this.report_settings.metrics || this.report_settings.groupby.length < 1 || this.report_settings.metrics.length < 1)
                    return {
                        rowData: [],
                        rowCount: 0,
                    };

                            
                dataurl += '&groupby=' + encodeURIComponent(JSON.stringify(this.report_settings.groupby));
                dataurl += '&metrics=' + encodeURIComponent(JSON.stringify(this.report_settings.metrics));
                if (this.report_settings.pivoton) {
                    dataurl += `&pivoton=${this.report_settings.pivoton}&PivotSize=${this.settings.max_pivot_columns}`;
                }

                if (this.TimeZone)
                    dataurl += '&WindowsTimeZone=' + encodeURIComponent(this.TimeZone);

                if (this.report_name)
                    dataurl += '&referenceid=' + encodeURIComponent(this.report_name);

                // If we want to override the call center's time zone, we can use this to get our browser's time zone:
                //  Intl.DateTimeFormat().resolvedOptions().timeZone

                console.log('url: ' + dataurl.split('&').join('\n'));
                this.query_in_progress = true;

                try {
                    const res = await utils.api.get(this.baseurl_flat + dataurl);

                    //console.log(`get returned ${res && res.rows ? res.rows.length : 0} row(s)`);
                    console.log('get returned:');
                    console.log(JSON.stringify({
                        took: res.took,
                        timed_out: res.timed_out,
                        total: res.total,
                        timezone: res.timezone,
                        after_key: res.after_key,
                        aggs: res.aggs,
                        append: res.append,
                        pivotDefs: res.pivotDefs,
                        rows_count: res.rows.length,
                        rows: res.rows.slice(0, 1),
                    },null,3));

                    this.next_after_key = res.after_key || null;

                    this.query_duration = res.took;
                    // Base appended totals on the requested offset so a repeated block
                    // cannot inflate rowCount and convince AG Grid that more rows exist.
                    this.total_rows = res.append ? (q_from + res.total) : res.total;
                    this.timezone = res.timezone;

                    //console.log('Results:');
                    //console.log(JSON.stringify(res.rows.slice(0, 3), null, 3));

                    if (res.pivotDefs) {
                        res.pivotDefs = res.pivotDefs.filter(p => !/_agg\d+$/.test(p));
                    }

                    this.pivot_columns = this.report_settings.pivoton ? res.pivotDefs : [];

                    if (this.report_settings.pivoton && res.pivotDefs && res.pivotDefs.length && !res.append)
                        this.generatePivotColumns(res.pivotDefs);

                    if (this.display_type == common.constants.DISPLAY_CHART) {
                        const g1 = this.report_settings.groupby[0];
                        const col = this.columnDefs.find(c => (g1.colId == 'datetime' && c.colId == 'starttime') || c.colId == g1.colId);
                        if (col) {
                            // Grab all column definitions for each metric aggregation
                            const mlist = this.report_settings.metrics.map(m => ({ metric: m, colDef: this.columnDefs.find(c => c.colId == m.colId) }));

                            // Generate axes and series for the chart
                            if (this.chartTypeSettings.type == 'pie' || this.chartTypeSettings.type == 'donut')
                                this.generatePieChartOptions(col, mlist);
                            else
                                this.generateXYChartOptions(col, mlist);
                        }

                        this.applyChartOptions(this.transformData(res.rows), this.custom_chart_options, this.custom_chart_legend);
                    }
                    else if (this.display_type == common.constants.DISPLAY_FLAT_GRID && q_from === 0) {
                        // Submit the same query but to the totals endpoint instead.
                        // Totals cover the whole query, so fetch them only for the first
                        // page. Updating pinned rows while a later block is loading can
                        // cause AG Grid to request that same block again.
                        this.pinnedBottomRowData = [{}];
                        const this_saved = this;
                        utils.api.get(this.baseurl_total + dataurl).then((rtn) => {
                            if (rtn && rtn.totals) {
                                if (rtn.totals._tooltipvalue)
                                    this.totals_row_class = 'grid-totals-row-warn';
                                else
                                    this.totals_row_class = 'grid-totals-row';

                                this_saved.pinnedBottomRowData = [rtn.totals];
                            }
                            else
                                this_saved.pinnedBottomRowData = null;
                        });
                    }

                    this.query_elapsed = `${res.took} ms`;
                    this.queryError = '';

                    return {
                        rowData: res.rows,
                        rowCount: this.total_rows + (res.total >= (params.endRow - params.startRow) ? 1 : 0),
                        //pivotResultFields: this.report_settings.pivoton ? res.pivotDefs : null
                    };
                }
                catch (ex) {
                    console.error(`Error: ${ex.message || ex.reasonPhrase}`);
                    this.queryError = ex.message || ex.reasonPhrase;

                    return {
                        rowData: [],
                        rowCount: 0,
                    };
                }
                finally {
                    this.query_in_progress = false;

                    // Check for any requests to refresh that were issued while a query was still in progress.
                    // Trigger a delayed refresh
                    if (this.query_refresh_pending) {
                        this.query_refresh_pending = false;
                        const thisref = this;
                        setTimeout(() => {
                            if (!thisref.query_in_progress)
                                thisref.RefreshAll();
                        }, 250);
                    }
                }
            },

            generatePivotColumns(pivotDefs) {             
                // Remove all previously configured auto-generated pivot columns
                for (let i = this.columnDefs.length - 1; i >= 0; i--) {
                    const item = this.columnDefs[i];

                    if (item.colId.substring(0, 6) == 'pivot_')
                        this.columnDefs.splice(i, 1);
                }

                if (this.gridApi){
                    //this.gridApi.resetColumnState();
                    // force ui update
                    this.gridApi.setGridOption('columnDefs', this.columnDefs);
                }
                // Extract a lookup list from the list of metric columns detected from the pivot column results, get the hide value, only show not hidden
                //const child_names = [...new Set(pivotDefs.map(a => a.split(common.constants.PIVOT_HEADER_SEP)[1]))].map(child => this.columnDefs.find(a => a.colId == child) || {colId: child, hide:true}).filter(a => a && a.hide);
                //const hiddenchildren = helps.toLookup(child_names, 'colId', 'hide');

                //console.log('generatePivotColumns; hiddenchildren:');
                //console.log(JSON.stringify(hiddenchildren, null, 3));

                for(let i=0; i<pivotDefs.length; i++) {
                    const item = pivotDefs[i];
                    if (!item.includes(common.constants.PIVOT_HEADER_SEP)) continue;

                    const group = item.split(common.constants.PIVOT_HEADER_SEP)[0] || '(Blank)';
                    const child = item.split(common.constants.PIVOT_HEADER_SEP)[1];

                    //console.log(`generatePivotColumns; [i:${i}] group:${group}; child:${child}; hiddenchildren[child]:${hiddenchildren[child]}`);

                    // Ensure metric columns are not visible, we are generating new columns to replace them
                    let metric_col = this.columnDefs.find(c => c.colId == child);
                    if (metric_col)
                        metric_col.hide = true;

                    //if (hiddenchildren[child]) continue;

                    let col = this.columnDefs.find(c => c.colId == 'pivot_' + group);
                    if (!col) {
                        col = {
                            colId: 'pivot_' + group,
                            headerName: group,
                            marryChildren: true,
                            hide: false,
                            children: []
                        };

                        let pivotcol = common.column_lookup[this.report_settings.pivoton];
                        if (pivotcol) {
                            switch (pivotcol.SourceType) {
                                case 'userIDColumn':
                                    col.headerValueGetter = (params) => this.getLegendFormatter(common.userLookup, true)({ value: item });
                                    break;

                                case 'customerIDColumn':
                                    col.headerValueGetter = (params) => this.getLegendFormatter(common.customerLookup, true)({ value: item });
                                    break;

                                case 'textSetColumn':
                                    if (pivotcol.lookups)
                                        col.headerValueGetter = (params) => this.getLegendFormatter(pivotcol.lookups, true)({ value: item });
                                    break;

                                case 'channelTypeColumn':
                                    col.headerValueGetter = (params) => this.legendChannelTypeFormatterNoSuffix({ value: item });
                                    break;
                            }
                        }

                        this.columnDefs.push(col);

                        console.log(`Creating pivot column: ${col.colId}; children:[${col.children.length}]`);
                    }
                    else
                        console.log(`Existing pivot column found: ${col.colId}; children:[${col.children.length}]`);

                    // Ex: child:timelineid_value_count_agg
                    const regex = /^(.*?)_(value_count|doc_count|sum|max|min|avg|cardinality|bucket|p50|p75|p90|p99)_agg$/;
                    const match = child.match(regex);
                    if (match) {
                        const colId = match[1];
                        const func = match[2];
                        const coldef = common.column_lookup[colId];
                        if (coldef) {
                            const newtype = common.getAggregateColumnType(colId, func, coldef.SourceType);

                            col.children.push({
                                headerName: common.formatHeader({ type: newtype, headerName: coldef.Title, aggFunc: func }),
                                field: item,
                                type: newtype,
                            });
                        }
                        else
                            console.warn(`Warning! Cannot lookup colId:${colId} - child:${child}`);
                    }
                    else
                        console.warn(`Warning! Cannot interpret metric, child:${child}`);
                }

                if (this.gridApi)
                    this.gridApi.setGridOption('columnDefs', this.columnDefs);
            },

            customizeSeries(prepared, pivotDefs) {
                // Combine what the prepard series is with the custom overrides.
                // Allows changing the chart type for example.
                const series = [];
                for (let i = 0; i < prepared.length; i++) {
                    if (this.customize_series && this.customize_series.length > i)
                        series.push({ ...prepared[i], ...this.customize_series[i] });
                    else
                        series.push(prepared[i]);
                }

                if (pivotDefs && pivotDefs.length) {
                    //const type = this.chartTypeSettings.type;
                    //let xKey = this.report_settings.groupby[0].colId;
                    //if (xKey == 'datetime') xKey = 'starttime';

                    //for(let p of pivotDefs) {
                    //    const group = p.split('~')[0] || '(Blank)';
                    //    const child = p.split('~')[1];
                    //    const s = {
                    //        type: type,
                    //        xKey: xKey,
                    //        yKey: p,
                    //    };
                    //    if (this.chartTypeSettings.stacked)
                    //        s.stackGroup = child;

                    //    series.push(s);
                    //}

                    // Remove all series that are not part of the pivotted columns
                    //for (let idx = series.findIndex(s => !s.yKey.includes('~')); idx >= 0; idx = series.findIndex(s => !s.yKey.includes('~'))) {
                    //    series.splice(idx, 1);
                    //}
                }

                console.log('customizeSeries:');
                console.log(JSON.stringify(series,null,3));

                return series;
            },
            customizeAxes(prepared, pivotDefs) {
                const axes = [];
                for (let i = 0; i < prepared.length; i++) {
                    if (this.customize_axes && this.customize_axes.length > i)
                        axes.push({ ...prepared[i], ...this.customize_axes[i] });
                    else
                        axes.push(prepared[i]);

                    //if (pivotDefs) {
                    //    const axis = axes[axes.length-1];
                    //    for (let p of pivotDefs) {
                    //        const child = p.split('~')[1];
                    //        if (axis.keys && axis.keys.includes(child))
                    //            axis.keys.push(p);
                    //    }
                    //}
                }
                if (this.customize_axes)
                    for (let i = prepared.length; i < this.customize_axes.length; i++) {
                        const extra = this.customize_axes[i];

                        // Reports saved by older Vue3 builds accumulated a duplicate axis pair on
                        // every chart refresh, each with a blank title. An untitled axis matching
                        // one already present cannot be identified or edited, so drop it rather
                        // than stacking it on the chart.
                        if (!extra.title?.text && axes.some(a => a.type == extra.type && a.position == extra.position))
                            continue;

                        axes.push(extra);

                        //if (pivotDefs) {
                        //    const axis = axes[axes.length - 1];
                        //    for (let p of pivotDefs) {
                        //        const child = p.split('~')[1];
                        //        if (axis.keys && axis.keys.includes(child))
                        //            axis.keys.push(p);
                        //    }
                        //}
                    }

                //if (pivotDefs && pivotDefs.length) {
                //    // Check for any axes that contain a column that is not one of the pivotted columns
                //    for (
                //        let idx = axes.findIndex(a => a.keys && a.keys.some(k => k.indexOf('~') < 0));
                //        idx >= 0;
                //        idx = axes.findIndex(a => a.keys && a.keys.some(k => k.indexOf('~') < 0))
                //        ) {
                //        const i = axes[idx].keys.findIndex(k => k.indexOf('~') < 0);
                //        if (i >= 0)
                //            axes[idx].keys.splice(i, 1);
                //    }
                //}

                //console.log('customizeAxes.prepared.axes:');
                //console.log(JSON.stringify(prepared, null, 3));

                //console.log('customizeAxes.customize_axes:');
                //console.log(JSON.stringify(this.customize_axes, null, 3));

                console.log('customizeAxes new axes:');
                console.log(JSON.stringify(axes, null, 3));
                return axes;
            },
            transformData(rows) {
                const result = [];
                for (let row of rows) {
                    const newrow = {};
                    for (let x of this.preparedChartOptions.transformer)
                        newrow[x.colId] = x.transform(row);
                    result.push(newrow);
                }
                console.log('Transformed Data:');
                console.log(JSON.stringify(result.slice(0, 3), null, 3));
                return result;
            },

            extractLegendHeaderName(child) {
                // Ex: child:timelineid_value_count_agg
                const regex = /^(.*?)_(value_count|doc_count|sum|max|min|avg|cardinality|p50|p75|p90|p99)_agg$/;
                const match = child.match(regex);
                if (match) {
                    const colId = match[1];
                    const func = match[2];
                    const coldef = common.column_lookup[colId];
                    if (coldef) {
                        const newtype = common.getAggregateColumnType(colId, func, coldef.SourceType);
                        return common.formatHeader({ type: newtype, headerName: coldef.Title, aggFunc: func });
                    }
                    else
                        console.warn(`extractLegendHeaderName cannot locate colId:${colId}, child:${child}`);
                }
                else
                    console.warn(`extractLegendHeaderName cannot interpret child:${child}`);

                return child;

            //    const parts = child.split('_');
            //    const func = parts[parts.length - 2];
            //    const idx = child.indexOf(`_${func}_agg`);

            //    const colId = idx >= 0 ? child.substring(0, idx) : child;
            //    const coldef = common.column_lookup[colId];
            //    const newtype = common.getAggregateColumnType(colId, func, coldef.SourceType);

            //    return common.formatHeader({ type: newtype, headerName: coldef.Title, aggFunc: func });
            },
            getChartSeriesText(row) {
                let result;

                if (this.report_settings.pivoton)
                    if (this.chartOptions?.legend?.item?.label?.formatter)
                        result = this.chartOptions.legend.item.label.formatter(row);
                
                if (result === undefined)
                    result = this.legendFormatter(row);

                //console.log(`- - - getChartSeriesText(row:${JSON.stringify(row)}): ${result}  (formatter? ${this.chartOptions?.legend?.item?.label?.formatter ? 'true' : 'false'})`);

                return result;
            },
            legendFormatter(row) {
                const col = this.columnDefs.find(a => a.colId == row.value);
                if (col)
                    return col.headerName;
                else if (!row.value)
                    return '(Blank)';
                else {
                    let idx = row.value.indexOf(common.constants.PIVOT_HEADER_SEP);
                    if (idx < 0)
                        return row.value;

                    const group = row.value.substring(0, idx) || '(Blank)';
                    const child = row.value.substring(idx + 1);
                    const name = this.extractLegendHeaderName(child);

                    return `${group}-${name}`;
                }
            },
            legendFormatterNoSuffix(row) {
                const col = this.columnDefs.find(a => a.colId == row.value);
                if (col)
                    return col.headerName;
                else if (!row.value)
                    return '(Blank)';
                else {
                    let idx = row.value.indexOf(common.constants.PIVOT_HEADER_SEP);
                    if (idx < 0)
                        return row.value;

                    return row.value.substring(0, idx) || '(Blank)';
                }
            },
            legendChannelTypeFormatter(row) {
                const col = this.columnDefs.find(a => a.colId == row.value);
                if (col)
                    return col.headerName;
                else {
                    let idx = row.value.indexOf(common.constants.PIVOT_HEADER_SEP);
                    if (idx < 0)
                        return row.value;

                    let group = row.value.substring(0, idx) || '(Blank)';
                    if (group.substring(0, 14) == 'CustomChannel~')
                        group = group.substring(14);

                    const child = row.value.substring(idx + 1);
                    const name = this.extractLegendHeaderName(child);

                    return `${group}-${name}`;
                }
            },
            legendChannelTypeFormatterNoSuffix(row) {
                const col = this.columnDefs.find(a => a.colId == row.value);
                if (col)
                    return col.headerName;
                else {
                    let idx = row.value.indexOf(common.constants.PIVOT_HEADER_SEP);
                    if (idx < 0)
                        return row.value;

                    let group = row.value.substring(0, idx) || '(Blank)';
                    if (group.substring(0, 14) == 'CustomChannel~')
                        group = group.substring(14);

                    return group;
                }
            },

            getLegendFormatter(lookup, suppress_metric_suffix) {
                return (row) => {
                    let idx = row.value.indexOf(common.constants.PIVOT_HEADER_SEP);
                    if (idx < 0)
                        return row.value;

                    let group = row.value.substring(0, idx) || '(Blank)';
                    if (lookup)
                        group = lookup[group] || group;

                    if (suppress_metric_suffix)
                        return group;

                    const child = row.value.substring(idx + 1);
                    const name = this.extractLegendHeaderName(child);

                    return `${group}-${name}`;
                }
            },

            customerLookupFormatter(v) {
                // v.value is the cell's content
                // v.data is the row data
                return common.customerLookup[v.value] || v.value;
            },
            userLookupFormatter(v) {
                let value;
                if (typeof v.value === 'object' && Array.isArray(v.value))
                    value = v.value.map(a => common.userLookup[a] || a).join(', ');
                else
                    value = common.userLookup[v.value] || v.value;

                //console.log(`customerLookupFormatter(v:${JSON.stringify(v.value)}): ${value}`);
                return value;
            },
            phoneNumLookupFormatter(v) {
                // note: v.data is the full row record
                switch (v.data.timelinetype) {
                    case 'Chat':
                        return common.chatLookup[v.value] || v.value;

                    case 'EMail':
                        return v.value;

                    case 'SMS':
                    case 'Fax':
                    case 'Call':
                    default:
                        if (v.value && v.value.substring(0, 4) == 'USER')
                            return common.userLookup[v.value.substring(4)] || v.value;
                        else if (v.value && v.value.length == 36)
                            return common.userLookup[v.value] || v.value;
                        else if (v.value == '+10000000000')
                            return '(Loopback)';
                        else
                            return helps.formatPhoneNumber(v.value);
                }
            },

            customerLookupComparator(a, b) {
                const ca = common.customerLookup[a] || a;
                const cb = common.customerLookup[b] || b;
                return ca > cb ? 1 : ca < cb ? -1 : 0;
            },
            userLookupComparator(a, b) {
                const ca = common.userLookup[a] || a;
                const cb = common.userLookup[b] || b;
                return ca > cb ? 1 : ca < cb ? -1 : 0;
            },
            phoneNumLookupComparator(a, b) {
                const ca = this.phoneNumLookupFormatter(a);
                const cb = this.phoneNumLookupFormatter(b);
                return ca > cb ? 1 : ca < cb ? -1 : 0;
            },

            getUniqueColValues(colname) {
                return async (params) => {
                    const dataurl = `${common.buildRequest('Apps/ReportStudio/AdvancedReporting/GetUniqueColValues', this.settings.startDate, this.settings.endDate)}&Column=${colname}`;

                    console.log(`getUniqueColValues (${colname}) url: ` + dataurl.split('&').join('\n'));

                    const res = await utils.api.get(dataurl);
                    params.success(res.Values);
                };
            },

            notifyCustomMetrics(cols, dsl) {
                //alert('notify custom metrics ' + JSON.stringify(cols) + '  -  ' + JSON.stringify(dsl));

                this.customMetrics = dsl;

                const colDefs = [
                    ...this.columnDefs.map(c => ({ colId: c.colId, field: c.field, headerName: c.headerName, type: c.type })),
                    //{ "colId": "count", "field": "count", "filter": false, "headerName": "Count", "hide": true, type: "countColumn" },
                    ...cols
                ];
                this.gridApi.setGridOption('columnDefs', colDefs);
            },

            remove_count(field) {
                if (field.length > 6 && field.substring(field.length - 6) == '_count')
                    return field.substring(0, field.length - 6);
                else
                    return '__ignore_me__';
            },

            onGridReady(params) {
                this.gridApi = params.api;
                this.columnApi = params.columnApi;

                if (this.refreshOnReady) {
                    this.refreshOnReady = false;
                    this.gridApi.setGridOption('columnDefs', this.columnDefs);
                    this.Refresh();
                }
            },
            onColumnMoved(e) {
                // e.finished is true ONLY when the user drops the column.
                // e.source !== 'api' ensures it doesn't fire when we drag a pill.
                if (e.finished && e.source !== 'api') {
                    const visiblecols = this.columnDefs.filter(a => a.colId && !a.hide).map(a => a.colId);
                    const colState = this.gridApi.getColumnState();
                    const newOrderedIds = colState.map(c => c.colId).filter(a => visiblecols.includes(a));
                    
                    this.processColumnOrderChange(newOrderedIds);
                }
            },
            processColumnOrderChange(newOrderedIds) {
                if (!this.report_settings) return;

                let needsQuery = false;

                // --- LOGIC FOR GROUPINGS ---
                if (this.report_settings.groupby) {
                    const existingGroupbyIds = this.report_settings.groupby.map(g => g.colId);
                    const newGroupedAndOrderedIds = newOrderedIds
                        .filter(id => existingGroupbyIds.includes(id) || (id === "starttime" && existingGroupbyIds.includes('datetime')))
                        .map(id => (id === "starttime" && existingGroupbyIds.includes('datetime')) ? 'datetime' : id);
                    
                    if (newGroupedAndOrderedIds.length === existingGroupbyIds.length && 
                        !_.isEqual(newGroupedAndOrderedIds, existingGroupbyIds)) {
                        
                        console.log('Grouping order changed by column move. Re-querying.');
                        const newGroupbySettings = newGroupedAndOrderedIds.map(id => 
                            this.report_settings.groupby.find(g => g.colId === id || (g.colId == "datetime" && id == "starttime"))
                        );
                        Vue.set(this.report_settings, 'groupby', newGroupbySettings);
                        needsQuery = true;
                    }
                }

                // --- LOGIC FOR METRICS ---
                if (this.report_settings.metrics && !this.isPillReordering) {
                    const existingMetrics = this.report_settings.metrics;
                    const existingMetricColIds = existingMetrics.map(m => `${m.colId}_${m.function}_agg`);
                    
                    const newOrderedMetricColIds = newOrderedIds.filter(id => existingMetricColIds.includes(id));
                    
                    if (newOrderedMetricColIds.length === existingMetricColIds.length &&
                        !_.isEqual(newOrderedMetricColIds, existingMetricColIds)) {
                        
                        console.log('Metric order changed by grid column move. Updating pills.');
                        const newMetricsOrder = newOrderedMetricColIds.map(fullColId => {
                            const match = fullColId.match(/^(.*?)_(value_count|doc_count|sum|max|min|avg|cardinality|bucket|p50|p75|p90|p99)_agg$/);
                            if (match) {
                                return { colId: match[1], function: match[2] };
                            }
                            return existingMetrics.find(m => `${m.colId}_${m.function}_agg` === fullColId);
                        }).filter(Boolean);
                        
                        Vue.set(this.report_settings, 'metrics', newMetricsOrder);
                    }
                }

                // Only requery if groupings changed
                if (needsQuery) {
                    this.applyTableReport(this.report_settings);
                }
            },
            stateUpdated(e) {
                console.log(`stateUpdated:${JSON.stringify(e.sources)}`);
                if (!e.sources.some(a => ['columnOrder', 'columnPinning', 'columnSizing', 'sort'].some(b => a == b)))
                    return;

                //const visiblecols = this.report_settings.metrics.map(a => a.colId).concat(this.report_settings.groupby.map(a => a.colId == 'datetime' ? 'starttime' : a.colId));
                const visiblecols = this.columnDefs.filter(a => a.colId && !a.hide).map(a => a.colId);

                //const state = this.column_state || {};
                if (e.sources.includes('columnSizing') && e.state.columnSizing)
                    Vue.set(this.column_state, 'columnSizing', e.state.columnSizing.columnSizingModel.filter(a => visiblecols.includes(a.colId) && a.width != 150));

                if (e.sources.includes('columnOrder') && e.state.columnOrder) {
                    // 1. Get the new ordered list of ALL visible column IDs
                    const newOrderedIds = e.state.columnOrder.orderedColIds.filter(a => visiblecols.includes(a));
                    // Always save the visual column order state
                    Vue.set(this.column_state, 'columnOrder', newOrderedIds);
                }

                if (e.sources.includes('columnPinning') && e.state.columnPinning) {
                    Vue.set(this.column_state, 'leftPinned', e.state.columnPinning.leftColIds.filter(a => visiblecols.includes(a)));
                    Vue.set(this.column_state, 'rightPinned', e.state.columnPinning.rightColIds.filter(a => visiblecols.includes(a)));
                }

                if (e.sources.includes('sort')) {
                    console.log(JSON.stringify(e.state.sort));
                    if (e.state.sort)
                        Vue.set(this.column_state, 'sort', e.state.sort.sortModel.filter(a => visiblecols.includes(a.colId)));
                    else
                        Vue.set(this.column_state, 'sort', []);
                }
                //Vue.set(this, 'column_state', state);

                //console.log('e.state.columnOrder: ' + JSON.stringify(e.state.columnOrder));
                //console.log('Saving state: ' + JSON.stringify(this.column_state));
                //console.log('visiblecols: ' + JSON.stringify(visiblecols));

                this.modelChanged();
            },
            onFirstDataRendered() {
                this.gridApi.autoSizeAllColumns();
                this.gridApi.refreshToolPanel();
            },
            getRowClass(params) {
                if (params.node.rowPinned === 'bottom')
                    return this.totals_row_class;
                else if (this.treeData && params.data && params.data.child_count < 0)
                    return 'child-row';

                return null;
            },
            chartDateLabel(value) {
                const shifted = this.chartDateValue(value);
                return typeof shifted === 'number' ? this.f_date(new Date(shifted), 'medium') : value;
            },
            chartDateValue(value) {
                const utcMs = Date.parse(value);
                if (isNaN(utcMs)) return value;
                if (!this.timezone) return utcMs;

                // ag-charts time axes and dayjs both render epoch values in the browser's
                // timezone with no override available, so offset the instant to make the
                // browser-local wall clock match the report timezone. Display only: these
                // values must never be sent back to the server.
                const shift = dayjs(utcMs).tz(this.timezone).utcOffset() - dayjs(utcMs).utcOffset();
                return utcMs + shift * 60000;
            },
            dateFormatter(value) {
                return this.f_date(value, 'medium');
            },
            durationFormatter(value) {
                if (typeof value === 'number')
                    return this.f_number(value);
                else
                    value;
            },
            phonenumFormatter(value) {
                return this.f_phoneNumber(value);
            },

            saveCommonDateRange() {
                utils.log(`Saving localStorage(${this.storageKey}-daterange, ${this.settings.startDate} - ${this.settings.endDate})`);
                this.System.LocalStorage(this.storageKey + '-daterange', `${this.settings.startDate} - ${this.settings.endDate}`);
            },
            applyDateRangeHandler(range) {
                console.log('applyDateRangeHandler');
                console.log(range.startDate);
                console.log(range.endDate);

                if (this.gridApi)
                    this.gridApi.ensureIndexVisible(0, 'top');

                var start = dayjs(range.startDate).format("YYYY-MM-DDTHH:mm:ss");
                var end = dayjs(range.endDate).format("YYYY-MM-DDTHH:mm:ss");

                this.settings.startDate = start;
                this.settings.endDate = end;
                utils.log(`Saving localStorage(${this.storageKey}-daterange, ${this.settings.startDate} - ${this.settings.endDate})`);
                this.System.LocalStorage(this.storageKey + '-daterange', `${this.settings.startDate} - ${this.settings.endDate}`);

                this.Refresh();
            },
            updateSimDateRange(range) {
                this.useStartEnd = true;
                this.applyDateRangeHandler(range);
            },
            clearDateRangeHandler() {
            },

            clearAllFilters() {
                this.EventBus.$emit('ClearAllReportFilters');
            },

            //getRowClass(params) {
            //    if (this.treeData && params.data && params.data.child_count < 0)
            //        return 'child-row';
            //},
            isServerSideGroup(dataItem) {
                return dataItem.child_count > 0;
            },
            getServerSideGroupKey(dataItem) {
                return dataItem.masterid;
            },

            gridSortChanged(event) {
                // When the sorting changes, we must reset to the top since OpenSearch cannot
                // preload a specific page number. If using bucket sorting, then it is possible
                // but then it is also much less efficient.
                if (this.gridApi)
                    this.gridApi.ensureIndexVisible(0, 'top');
            },

            autoSizeAllColumns() {
                this.gridApi.autoSizeAllColumns();
            },
            sizeColumnsToFit() {
                this.gridApi.sizeColumnsToFit();
            },
            updateUseStartEnd(value) {
                this.useStartEnd = value;
                this.Refresh();
            },

            reportNameChanged(newvalue) {
                this.report_name = newvalue;
                if (this.setReportNameFunction)
                    this.setReportNameFunction(newvalue, this, helps, Vue);

                this.modelChanged();
            },
            reportDescChanged(newvalue) {
                this.report_description = newvalue;
                if (this.setReportDescriptionFunction)
                    this.setReportDescriptionFunction(newvalue, this, helps, Vue);

                this.modelChanged();
            },
            reportCategoryChanged(newvalue) {
                this.report_category = newvalue;
                if (this.setReportCategoryFunction)
                    this.setReportCategoryFunction(newvalue, this, helps, Vue);

                this.modelChanged();
            },            

            setColumnsVisible(cols, value) {
                const cdefs = this.columnDefs.filter(c => cols.includes(c.colId));
                
                for (let c of cdefs)
                    c.hide = !value;
                
                this.visibleColumnIds = this.columnDefs.filter(a => a.colId && !a.hide).map(a => a.colId);
                console.log(`setColumnsVisible(cols:${JSON.stringify(cols)}, value:${value})`);
                this.gridApi.setColumnsVisible(cols, value);

                this.modelChanged();

                // Only refresh when adding columns, otherwise, it's a waste
                if (value)
                    this.Refresh();

                //if (this.ReadOnly) {
                //    // In view mode, save the column visibility to local storage
                //    const colstate = this.viewonly_settings.column_picker_list
                //        .map(a => this.columnDefs.find(b => b.colId == a.ColId))
                //        .map(c => ({ colId: c.colId, visible: !c.hide }));

                //    this.System.LocalStorage(this.storageKey + '-columnsvisible', JSON.stringify(colstate));
                //}
            },
            showDataFilters() {
                this.show_filters = true;
            },

            cycleDurationFormats() {
                this.durationFormatIdx = (this.durationFormatIdx + 1) % 3;
                this.gridApi.refreshCells();
                this.Refresh();
            },

            groupbyordered(args) {
                console.log(`report groupbyordered received: ${JSON.stringify(args)}`);
                if (this.gridApi)
                    for (let a of args)
                        this.gridApi.moveColumn(a.colId, a.toIndex);
            },
            metricsordered(newMetrics) {
                if (!this.report_settings || !this.report_settings.metrics) return;

                const newSettingsMetrics = newMetrics.map(m => ({
                    colId: m.ColId,
                    function: m.calculation
                }));
                Vue.set(this.report_settings, 'metrics', newSettingsMetrics);

                setTimeout(() => {
                    this.isPillReordering = true; 
                    
                    if (this.gridApi) {
                        let colState = this.gridApi.getColumnState();
                        const metricColIds = colState.filter(c => c.colId.endsWith('_agg')).map(c => c.colId);
                        
                        if (metricColIds.length > 0) {
                            const firstMetricIndex = colState.findIndex(c => metricColIds.includes(c.colId));
                            const nonMetricState = colState.filter(c => !metricColIds.includes(c.colId));
                            
                            const newMetricState = newMetrics.map(m => {
                                const fullColId = `${m.ColId}_${m.calculation}_agg`;
                                return colState.find(c => c.colId === fullColId);
                            }).filter(Boolean);
                            
                            nonMetricState.splice(firstMetricIndex, 0, ...newMetricState);
                            this.gridApi.applyColumnState({ state: nonMetricState, applyOrder: true });
                        }
                    }
                    
                    this.modelChanged();

                    setTimeout(() => { this.isPillReordering = false; }, 250);
                }, 0);
            },
        },
        watch: {
            todisplay: function (newv) {
                if (newv && this.colDefsLoaded)
                    this.loadReportModel();
            },
            treeData: function (newvalue) {
                this.gridApi.setColumnsVisible(['starttime'], !newvalue);
                this.autoGroupColumnDef = newvalue ?
                    this.groupColDef_byMasterID :
                    this.groupColDef_Normal;
            },
            display_type: function (newvalue) {
                if (this.display_type == common.constants.DISPLAY_RESIZING) return;

                this.System.LocalStorage(this.storageKey + '-display_type', `${newvalue}`);

                // Ensure the grid is not paged down somewhere when we switch to the chart, it will cause
                // weird attempts to load the correct page but in chart mode, we will only start at page 0.
                if (this.gridApi && newvalue == common.constants.DISPLAY_CHART)
                    this.gridApi.ensureIndexVisible(0, 'top');

                this.applyTableReport(this.report_settings);
                this.Refresh();
            },
            show_filters: function (newvalue) {
                if (this.display_type == common.constants.DISPLAY_CHART && newvalue) {
                    // The filters are being activated while in chart mode, refresh chart to make it resize
                    this.display_type = common.constants.DISPLAY_RESIZING;
                    const thisref = this;
                    setTimeout(() => {
                        thisref.display_type = common.constants.DISPLAY_CHART;
                    }, 10);
                }
            },
            active_source: function (newvalue) {
                this.System.LocalStorage(this.storageKey + '-source', this.active_source);
                this.Refresh();
            },
            tool_visible: function (newvalue, oldvalue) {
                console.log(`tool_visible: new:${newvalue}, old:${oldvalue}, display_type:${this.display_type}`);

                if (this.display_type == common.constants.DISPLAY_CHART && oldvalue === undefined && newvalue !== undefined) {
                    // Forcibly toggle visibility of chart
                    this.display_type = common.constants.DISPLAY_RESIZING;
                    const thisref = this;
                    setTimeout(() => {
                        thisref.display_type = common.constants.DISPLAY_CHART;
                    }, 10);
                }
            },
            TimeZone: function (newvalue) {
                if (newvalue)
                    this.Refresh();
            },
        }
    };
</script>

<style>
    .child-row {
        background-color: cornsilk !important;
    }
    .grid-totals-row {
        font-weight: bold;
    }
    .grid-totals-row-warn {
        font-weight: bold;
        color: red !important;
    }

    .mychart {
        flex-grow: 1;
        /*max-height: 400px;*/
    }
    .right-aligned-cell {
        text-align: right;
        flex-direction: column-reverse;
    }
    .icon-spinner {
        animation: spin-animation 1.5s infinite;
        display: inline-block;
    }
    .v-expansion-panel-header {
        background-color: var(--v-extraLightGrey-base);
    }
    .v-expansion-panel-content {
        background-color: var(--v-extraLightGrey-base);
    }

    @keyframes spin-animation {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(359deg);
        }
    }
    
</style>
